// This file is auto-generated. Do not edit directly.
import type { IngredientDatabase, System, Setting } from '../types';

export const defaultDatabase: IngredientDatabase = {
  "ingredients": {
    "acetyl_alcohol": {
      "name": "Acetyl Alcohol",
      "id": "acetyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "amino_methyl_propanol": {
      "name": "Amino Methyl Propanol",
      "id": "amino_methyl_propanol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "amino_2_methyl_1_propanol": {
      "name": "Amino-2-Methyl-1-Propanol",
      "id": "amino_2_methyl_1_propanol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "amylcinnamyl_alcohol": {
      "name": "Amylcinnamyl Alcohol",
      "id": "amylcinnamyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "synonyms": [
        "amyl cinnamyl alcohol"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "arachidyl_alcohol": {
      "name": "Arachidyl Alcohol",
      "id": "arachidyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "behenyl_alcohol": {
      "name": "Behenyl Alcohol",
      "id": "behenyl_alcohol",
      "synonyms": [
        "docosanol",
        "behenic alcohol"
      ],
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "benzyl_alcohol": {
      "name": "Benzyl Alcohol",
      "id": "benzyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/benzyl-alcohol",
          "title": "INCIDecor",
          "status": "ok"
        }
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "brassica_alcohol": {
      "name": "Brassica Alcohol",
      "id": "brassica_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "butylene_alcohol": {
      "name": "Butylene Alcohol",
      "id": "butylene_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "c14_22_alcohol": {
      "name": "C14-22 Alcohol",
      "id": "c14_22_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "c20_c22_alcohol": {
      "name": "C20-C22 Alcohol",
      "id": "c20_c22_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "c30_50_alcohols": {
      "name": "C30-50 Alcohols",
      "id": "c30_50_alcohols",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "cetearyl_alcohol": {
      "name": "Cetearyl Alcohol",
      "id": "cetearyl_alcohol",
      "synonyms": [
        "cetyl stearyl alcohol",
        "cetostearyl alcohol",
        "c16-18 alcohols",
        "ceteryl alcohol"
      ],
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "cetyl_alcohol": {
      "name": "Cetyl Alcohol",
      "id": "cetyl_alcohol",
      "synonyms": [
        "cetanol",
        "1-hexadecanol",
        "palmityl alcohol",
        "hexadecyl alcohol",
        "palmitoryl alcohol",
        "c16 alcohol l"
      ],
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "cetylated_lanolin_alcohol": {
      "name": "Cetylated Lanolin Alcohol",
      "id": "cetylated_lanolin_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "cinnamyl_alcohol": {
      "name": "Cinnamyl Alcohol",
      "id": "cinnamyl_alcohol",
      "synonyms": [
        "cinnamic alcohol"
      ],
      "categories": [
        "emollient_alcohols"
      ],
      "description": "If you think the name sounds like cinnamon, you're right! This is a naturally occuring compound found in cinnamon, used mainly for its pleasant scent.",
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/cinnamyl-alcohol",
          "title": "INCIDecoder",
          "status": "ok"
        }
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "coconut_alcohol": {
      "name": "Coconut Alcohol",
      "id": "coconut_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "ethyl_alcohol": {
      "name": "Ethyl Alcohol",
      "id": "ethyl_alcohol",
      "synonyms": [
        "grain alcohol",
        "sugarcane-derived alcohol",
        "sugarcane alcohol"
      ],
      "categories": [
        "drying_alcohols"
      ],
      "status": "caution",
      "group": "alcohols"
    },
    "isocetyl_alcohol": {
      "name": "Isocetyl Alcohol",
      "id": "isocetyl_alcohol",
      "synonyms": [
        "isohexadecanol"
      ],
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "isopropyl_alcohol": {
      "name": "Isopropyl alcohol",
      "id": "isopropyl_alcohol",
      "synonyms": [
        "isopropanol",
        "2-propanol"
      ],
      "categories": [
        "drying_alcohols"
      ],
      "status": "caution",
      "group": "alcohols"
    },
    "isostearyl_alcohol": {
      "name": "Isostearyl Alcohol",
      "id": "isostearyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "lanolin_alcohol": {
      "name": "Lanolin Alcohol",
      "id": "lanolin_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "lauryl_alcohol": {
      "name": "Lauryl Alcohol",
      "id": "lauryl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "synonyms": [
        "1-dodecanol",
        "dodecanol",
        "dodecyl alcohol"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "myristyl_alcohol": {
      "name": "Myristyl Alcohol",
      "id": "myristyl_alcohol",
      "synonyms": [
        "1-tetradecanol",
        "tetradecan-1-ol"
      ],
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "oleyl_alcohol": {
      "name": "Oleyl Alcohol",
      "id": "oleyl_alcohol",
      "synonyms": [
        "oleic alcohol"
      ],
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "phenethyl_alcohol": {
      "name": "Phenethyl Alcohol",
      "id": "phenethyl_alcohol",
      "synonyms": [
        "phenylethyl alcohol",
        "phenyl ethyl alcohol"
      ],
      "categories": [
        "drying_alcohols"
      ],
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/phenethyl-alcohol",
          "title": "INCIDecoder",
          "status": "ok"
        }
      ],
      "description": "Phenethyl alcohol usually used as a preservative or for scent (it has a rose-like scent) in small amounts. In this context it's unlikely to be drying or irritating.",
      "status": "caution",
      "group": "alcohols"
    },
    "propyl_alcohol": {
      "name": "Propyl Alcohol",
      "id": "propyl_alcohol",
      "categories": [
        "drying_alcohols"
      ],
      "status": "caution",
      "group": "alcohols"
    },
    "alcohol_denat": {
      "name": "Alcohol Denat",
      "id": "alcohol_denat",
      "synonyms": [
        "alcohol denat",
        "alcohol-40b",
        "denatured alcohol",
        "sd alcohol",
        "sugarcane derived alcohol",
        "alcohol"
      ],
      "categories": [
        "drying_alcohols"
      ],
      "description": "This is literally alcohol, like the kind in a bottle of vodka, except its been denatured, a process that makes it undrinkable.",
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/alcohol-denat",
          "title": "INCIDecoder",
          "description": "Says it can be drying if its in the first few ingredients of a product",
          "type": "science",
          "status": "caution"
        },
        {
          "url": "http://www.tightlycurly.com/ingredients/",
          "title": "Tightly Curly Ingredients",
          "type": "author",
          "date": "2010",
          "source": "Tightly Curly",
          "description": "Says to avoid alcohol denat",
          "status": "warning"
        }
      ],
      "status": "caution",
      "group": "alcohols"
    },
    "stearyl_alcohol": {
      "name": "Stearyl Alcohol",
      "id": "stearyl_alcohol",
      "synonyms": [
        "1-octadecanol",
        "octadecan-1-ol",
        "steoryl alcohol",
        "steareth alcohol"
      ],
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "undecyl_alcohol": {
      "name": "Undecyl Alcohol",
      "id": "undecyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "emulsifying_wax": {
      "name": "Emulsifying Wax",
      "id": "emulsifying_wax",
      "categories": [
        "emollient_alcohols"
      ],
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/emulsifying-wax",
          "title": "INCIDecoder",
          "description": "This isn't an INCI ingredient, they think it's a mix of Cetearyl Alcohol (and) Polysorbate 60",
          "status": "ok"
        }
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "hydrogenated_dilinoleyl_alcohol": {
      "name": "Hydrogenated Dilinoleyl Alcohol",
      "id": "hydrogenated_dilinoleyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "batyl_alcohol": {
      "name": "Batyl Alcohol",
      "id": "batyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "c12_15_alcohol": {
      "name": "C12-15 Alcohol",
      "id": "c12_15_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "c12_16_alcohol": {
      "name": "C12-16 Alcohol",
      "id": "c12_16_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "decyl_alcohol": {
      "name": "Decyl Alcohol",
      "id": "decyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "hydrogenated_rapeseed_alcohol": {
      "name": "Hydrogenated Rapeseed Alcohol",
      "id": "hydrogenated_rapeseed_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "jojoba_alcohol": {
      "name": "Jojoba Alcohol",
      "id": "jojoba_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "tridecyl_alcohol": {
      "name": "Tridecyl Alcohol",
      "id": "tridecyl_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "status": "ok",
      "group": "alcohols"
    },
    "fatty_alcohol": {
      "name": "Fatty Alcohol",
      "id": "fatty_alcohol",
      "categories": [
        "emollient_alcohols"
      ],
      "description": "This is probably part of an ingredient list that's just labeling another ingredient",
      "status": "caution",
      "group": "alcohols"
    },
    "alkylbenzene_sulfonate": {
      "name": "Alkylbenzene Sulfonate",
      "id": "alkylbenzene_sulfonate",
      "synonyms": [
        "alkylbenzene sulphate",
        "alkyl benzene sulfonate",
        "alkyl benzene sulphate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "ammonium_cocoyl_isethionate": {
      "name": "Ammonium Cocoyl Isethionate",
      "id": "ammonium_cocoyl_isethionate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "ammonium_cocoyl_sulfate": {
      "name": "Ammonium Cocoyl Sulfate",
      "id": "ammonium_cocoyl_sulfate",
      "synonyms": [
        "ammonium cocoyl sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "ammonium_laureth_sulfate": {
      "name": "Ammonium Laureth Sulfate",
      "id": "ammonium_laureth_sulfate",
      "synonyms": [
        "ammonium laureth sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "ammonium_lauryl_sulfate": {
      "name": "Ammonium Lauryl Sulfate",
      "id": "ammonium_lauryl_sulfate",
      "synonyms": [
        "ammonium lauryl sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "ammonium_xylenesulfonate": {
      "name": "Ammonium Xylenesulfonate",
      "id": "ammonium_xylenesulfonate",
      "synonyms": [
        "ammonium xylenesulphate",
        "ammonium xylene-sulfonate",
        "ammonium xylene sulfonate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "babassuamidopropyl_betaine": {
      "name": "Babassuamidopropyl Betaine",
      "id": "babassuamidopropyl_betaine",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "capryl_glucoside": {
      "name": "Capryl Glucoside",
      "id": "capryl_glucoside",
      "synonyms": [
        "capryl glucoside, caprylyl glucoside"
      ],
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "cocamidopropyl_betaine": {
      "name": "Cocamidopropyl Betaine",
      "id": "cocamidopropyl_betaine",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "cocamidopropyl_hydroxysultaine": {
      "name": "Cocamidopropyl Hydroxysultaine",
      "id": "cocamidopropyl_hydroxysultaine",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "coco_betaine": {
      "name": "Coco Betaine",
      "id": "coco_betaine",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "coco_glucoside": {
      "name": "Coco Glucoside",
      "id": "coco_glucoside",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "cocamide_mea": {
      "name": "Cocamide MEA",
      "id": "cocamide_mea",
      "synonyms": [
        "coconut monoethanolamide"
      ],
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "decyl_glucoside": {
      "name": "Decyl Glucoside",
      "id": "decyl_glucoside",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "decyl_polyglucose": {
      "name": "Decyl Polyglucose",
      "id": "decyl_polyglucose",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "dioctyl_sodium_sulfosuccinate": {
      "name": "Dioctyl Sodium Sulfosuccinate",
      "id": "dioctyl_sodium_sulfosuccinate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "disodium_cocoamphodiacetate": {
      "name": "Disodium Cocoamphodiacetate",
      "id": "disodium_cocoamphodiacetate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "disodium_cocoamphodipropionate": {
      "name": "Disodium Cocoamphodipropionate",
      "id": "disodium_cocoamphodipropionate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "disodium_cocoyl_glutamate": {
      "name": "Disodium Cocoyl Glutamate",
      "id": "disodium_cocoyl_glutamate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "disodium_laureth_succinate": {
      "name": "Disodium Laureth Succinate",
      "id": "disodium_laureth_succinate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "disodium_laureth_sulfosuccinate": {
      "name": "Disodium Laureth Sulfosuccinate",
      "id": "disodium_laureth_sulfosuccinate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "disodium_lauryl_sulfosuccinate": {
      "name": "Disodium Lauryl Sulfosuccinate",
      "id": "disodium_lauryl_sulfosuccinate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "ethyl_peg_15_cocamine_sulfate": {
      "name": "Ethyl PEG-15 Cocamine Sulfate",
      "id": "ethyl_peg_15_cocamine_sulfate",
      "synonyms": [
        "ethyl peg-15 cocamine sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "lauryl_glucoside": {
      "name": "Lauryl Glucoside",
      "id": "lauryl_glucoside",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "lauryl_hydroxysultaine": {
      "name": "Lauryl Hydroxysultaine",
      "id": "lauryl_hydroxysultaine",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_alkyl_sulfate": {
      "name": "Sodium Alkyl Sulfate",
      "id": "sodium_alkyl_sulfate",
      "synonyms": [
        "sodium alkyl sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_c12_14_olefin_sulfonate": {
      "name": "Sodium C12-14 Olefin Sulfonate",
      "id": "sodium_c12_14_olefin_sulfonate",
      "synonyms": [
        "sodium c12-14 olefin sulphate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_c12_18_alkyl_sulfate": {
      "name": "Sodium C12-18 Alkyl Sulfate",
      "id": "sodium_c12_18_alkyl_sulfate",
      "synonyms": [
        "sodium c12-18 alkyl sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_c14_15_olefin_sulfonate": {
      "name": "Sodium C14-15 Olefin Sulfonate",
      "id": "sodium_c14_15_olefin_sulfonate",
      "synonyms": [
        "sodium c14-15 olefin sulphate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_c14_16_olefin_sulfonate": {
      "name": "Sodium C14-16 Olefin Sulfonate",
      "id": "sodium_c14_16_olefin_sulfonate",
      "synonyms": [
        "sodium c14-16 olefin sulphate",
        "sodium c14 16 olefin sulfonate",
        "sodium c1416 olefin sulfonate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_c14_18_olefin_sulfonate": {
      "name": "Sodium C14-18 Olefin Sulfonate",
      "id": "sodium_c14_18_olefin_sulfonate",
      "synonyms": [
        "sodium c14-18 olefin sulphate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_c14_26_olefin_sulfonate": {
      "name": "Sodium C14-26 Olefin Sulfonate",
      "id": "sodium_c14_26_olefin_sulfonate",
      "synonyms": [
        "sodium c14-26 olefin sulphate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_c16_18_olefin_sulfonate": {
      "name": "Sodium C16-18 Olefin Sulfonate",
      "id": "sodium_c16_18_olefin_sulfonate",
      "synonyms": [
        "sodium c16-18 olefin sulphate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_cetearyl_sulfate": {
      "name": "Sodium Cetearyl Sulfate",
      "id": "sodium_cetearyl_sulfate",
      "synonyms": [
        "sodium cetearyl sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_coceth_sulfate": {
      "name": "Sodium Coceth Sulfate",
      "id": "sodium_coceth_sulfate",
      "synonyms": [
        "sodium coceth sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_coco_sulfate": {
      "name": "Sodium Coco Sulfate",
      "id": "sodium_coco_sulfate",
      "synonyms": [
        "sodium coco sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_cocoamphoacetate": {
      "name": "Sodium Cocoamphoacetate",
      "id": "sodium_cocoamphoacetate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_cocosulfate": {
      "name": "Sodium Cocosulfate",
      "id": "sodium_cocosulfate",
      "synonyms": [
        "sodium cocosulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_cocoyl_glutamate": {
      "name": "Sodium Cocoyl Glutamate",
      "id": "sodium_cocoyl_glutamate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_cocoyl_isethionate": {
      "name": "Sodium Cocoyl Isethionate",
      "id": "sodium_cocoyl_isethionate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_cocoyl_sarcosinate": {
      "name": "Sodium Cocoyl Sarcosinate",
      "id": "sodium_cocoyl_sarcosinate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_laureth_sulfate": {
      "name": "Sodium Laureth Sulfate",
      "id": "sodium_laureth_sulfate",
      "synonyms": [
        "sodium laureth sulphate",
        "sles"
      ],
      "categories": [
        "sulfates"
      ],
      "description": "Not to be confused with SLS (sodium lauryl sulfate), as it is known to be milder.",
      "references": [
        {
          "url": "https://www.paulaschoice.com/ingredient-dictionary/ingredient-sodium-laureth-sulfate.html",
          "title": "Paula's Choice",
          "type": "author",
          "status": "good"
        },
        {
          "url": "https://amzn.to/41QrGxJ",
          "title": "Curly Girl: The Handbook",
          "type": "hairpro",
          "author": "Massey L.",
          "date": "2011",
          "status": "warning"
        },
        {
          "url": "https://incidecoder.com/ingredients/sodium-laureth-sulfate",
          "title": "INCIdecoder",
          "type": "science",
          "status": "ok"
        },
        {
          "url": "http://www.tightlycurly.com/ingredients/",
          "title": "Tightly Curly Ingredients",
          "type": "author",
          "date": "2010",
          "source": "Tightly Curly",
          "status": "ok"
        }
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_laureth_40_sulfate": {
      "name": "Sodium Laureth-40 Sulfate",
      "id": "sodium_laureth_40_sulfate",
      "synonyms": [
        "sodium laureth-40 sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_lauroamphoacetate": {
      "name": "Sodium Lauroamphoacetate",
      "id": "sodium_lauroamphoacetate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_lauroyl_glutamate": {
      "name": "Sodium Lauroyl Glutamate",
      "id": "sodium_lauroyl_glutamate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_lauroyl_methyl_isethionate": {
      "name": "Sodium Lauroyl Methyl Isethionate",
      "id": "sodium_lauroyl_methyl_isethionate",
      "synonyms": [
        "sodium lauryl methyl isothionate",
        "sodium lauroyl methyl lsethionate",
        "sodium lauroylmethyl isethionate"
      ],
      "categories": [
        "mild_surfactants"
      ],
      "description": "CurlsBot is in the process of reclassifying this ingredient. We believe it is a mild surfactant but in the past we've listed it as stronger",
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_lauryl_glucose_carboxylate": {
      "name": "Sodium Lauryl Glucose Carboxylate",
      "id": "sodium_lauryl_glucose_carboxylate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_lauryl_sarcosinate": {
      "name": "Sodium Lauryl Sarcosinate",
      "id": "sodium_lauryl_sarcosinate",
      "synonyms": [
        "sodium lauroyl sarcosinate",
        "sodium lauroyl sarcosine"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_lauryl_sulfate": {
      "name": "Sodium Lauryl Sulfate",
      "id": "sodium_lauryl_sulfate",
      "synonyms": [
        "sodium lauryl sulphate",
        "sls"
      ],
      "categories": [
        "sulfates"
      ],
      "description": "Probably one of the most infamous sulfates. It's a strong cleanser that can be drying to hair. It's also a common irritant for people with sensitive skin. However, as always, much depends on the formulation.",
      "references": [
        {
          "url": "http://www.tightlycurly.com/Ingredients.aspx?ingredientName=Sodium%20lauryl%20sulfate",
          "title": "Tightly Curly",
          "type": "author",
          "status": "warning"
        },
        {
          "url": "https://incidecoder.com/ingredients/sodium-lauryl-sulfate",
          "title": "INCIdecoder",
          "type": "science",
          "status": "warning"
        },
        {
          "url": "https://www.paulaschoice.com/ingredient-dictionary/ingredient-sodium-lauryl-sulfate.html",
          "title": "Paula's Choice",
          "type": "author",
          "status": "warning"
        },
        {
          "url": "https://amzn.to/41QrGxJ",
          "title": "Curly Girl: The Handbook",
          "type": "hairpro",
          "author": "Massey L.",
          "date": "2011",
          "status": "warning"
        },
        {
          "url": "https://www.epa.gov/saferchoice/safer-ingredients",
          "title": "EPA Safer Choice",
          "type": "science",
          "status": "ok"
        },
        {
          "url": "https://thebeautybrains.com/2007/06/sulfates-in-shampoos-what-are-they/",
          "title": "The Beauty Brains",
          "type": "science",
          "status": "ok"
        },
        {
          "url": "https://labmuffin.com/the-science-of-hair-products-shampoo-and-conditioner-with-video/",
          "title": "Lab Muffin: The Science of Hair Products: Shampoo and Conditioner",
          "type": "science",
          "status": "ok"
        }
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_lauryl_sulfoacetate": {
      "name": "Sodium Lauryl Sulfoacetate",
      "id": "sodium_lauryl_sulfoacetate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_laurylglucosides_hydroxypropylsulfonate": {
      "name": "Sodium Laurylglucosides Hydroxypropylsulfonate",
      "id": "sodium_laurylglucosides_hydroxypropylsulfonate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_methyl_cocoyl_taurate": {
      "name": "Sodium Methyl Cocoyl Taurate",
      "id": "sodium_methyl_cocoyl_taurate",
      "categories": [
        "mild_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_myreth_sulfate": {
      "name": "Sodium Myreth Sulfate",
      "id": "sodium_myreth_sulfate",
      "synonyms": [
        "sodium myreth sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_myristoyl_sarcosinate": {
      "name": "Sodium Myristoyl Sarcosinate",
      "id": "sodium_myristoyl_sarcosinate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_polystyrene_sulfate": {
      "name": "Sodium Polystyrene Sulfate",
      "id": "sodium_polystyrene_sulfate",
      "synonyms": [
        "sodium polystyrene sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_xylenesulfonate": {
      "name": "Sodium Xylenesulfonate",
      "id": "sodium_xylenesulfonate",
      "synonyms": [
        "sodium xylenesulphate",
        "sodium xylene-sulfonate",
        "sodium xylene sulfonate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "tea_dodecylbenzenesulfonate": {
      "name": "Tea Dodecylbenzenesulfonate",
      "id": "tea_dodecylbenzenesulfonate",
      "synonyms": [
        "tea-dodecylbenzenesulfonate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "tea_lauryl_sulfate": {
      "name": "Tea Lauryl Sulfate",
      "id": "tea_lauryl_sulfate",
      "synonyms": [
        "tea lauryl sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "triethanolamine_lauryl_sulfate": {
      "name": "Triethanolamine Lauryl Sulfate",
      "id": "triethanolamine_lauryl_sulfate",
      "synonyms": [
        "triethanolamine lauryl sulphate"
      ],
      "categories": [
        "sulfates"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sulfonate": {
      "name": "Sulfonate",
      "id": "sulfonate",
      "synonyms": [
        " sulfonate"
      ],
      "categories": [
        "other_anionic_surfactants"
      ],
      "description": "We're pretty sure this is a sulfonate, but we're not sure which one. ",
      "status": "ok",
      "group": "surfactants"
    },
    "behentrimonium_chloride": {
      "name": "Behentrimonium Chloride",
      "id": "behentrimonium_chloride",
      "description": "A cationic surfactant that gently cleanses and conditions hair",
      "categories": [
        "conditioning_agents"
      ],
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/behentrimonium-chloride"
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "cetrimonium_chloride": {
      "name": "Cetrimonium Chloride",
      "id": "cetrimonium_chloride",
      "description": "A cationic surfactant that gently cleanses and conditions hair",
      "categories": [
        "conditioning_agents"
      ],
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/cetrimonium-chloride"
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Organo-Modified Siloxane Polymers for Conditioning",
          "type": "science",
          "author": "Abrutyn, Eric S.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "A quat (not a polyquat) that has good substantivity (ability to adhere and stay on hair)."
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "behentrimonium_methosulfate": {
      "name": "Behentrimonium Methosulfate",
      "id": "behentrimonium_methosulfate",
      "categories": [
        "conditioning_agents"
      ],
      "description": "Despite the name, this is not a sulfate. It a cationic surfactant that gently cleanses and conditions hair.",
      "status": "ok",
      "group": "others"
    },
    "stearamidopropyl_dimethylamine": {
      "name": "Stearamidopropyl Dimethylamine",
      "id": "stearamidopropyl_dimethylamine",
      "categories": [
        "conditioning_agents"
      ],
      "description": "A cationic surfactant used for conditioning hair",
      "status": "ok",
      "group": "others"
    },
    "apricot_kernel_oil": {
      "name": "Apricot Kernel Oil",
      "id": "apricot_kernel_oil",
      "synonyms": [
        "prunus armeniaca kernel oil",
        "apricot seed oil"
      ],
      "categories": [
        "medium_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Apricot kernel oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have moderate penetration (similar to olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "safflower_oil": {
      "name": "Safflower Oil",
      "id": "safflower_oil",
      "categories": [
        "light_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Safflower oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have low moderate penetration (lower than olive oil, and much less than coconut oil)"
        },
        {
          "url": "https://pubmed.ncbi.nlm.nih.gov/38922913/",
          "title": "Penetration of oils into hair",
          "description": "Found that camellia oil can penetrate the hair shaft  at a low-moderate level compared to high penetration oils like coconut. It also found that safflower oil was just as good as coconut oil at preventing damage.",
          "type": "science"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "argan_oil": {
      "name": "Argan Oil",
      "id": "argan_oil",
      "synonyms": [
        "argania spinosa kernel oil",
        "argan tree oil"
      ],
      "categories": [
        "medium_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Argan Oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have moderate penetration (similar to olive oil, and much less than coconut oil)"
        },
        {
          "url": "https://link.springer.com/article/10.1186/s40691-021-00282-5",
          "title": "Effect of rinse-off hair conditioner containing argan oil or camellia oil on the recovery of hair damaged by bleaching",
          "description": "Study found argan oil was effective at protecting bleached hair from damage, moreso than camellia oil",
          "type": "science"
        },
        {
          "url": "https://www.mdpi.com/2079-9284/11/2/64",
          "title": "Impact of Hair Damage on the Penetration Profile of Coconut, Avocado, and Argan Oils into Caucasian Hair Fibers",
          "type": "science",
          "description": "Found that argan oil could penetrate the hair shaft but not as well as coconut oil. Also found that argan oil increased susceptibility to breakage by making it more vulnerable to water/humidity",
          "status": "caution"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "cocoa_butter": {
      "name": "Cocoa Butter",
      "id": "cocoa_butter",
      "synonyms": [
        "theobroma cacao seed butter",
        "cacao seed butter"
      ],
      "categories": [
        "light_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Cocoa butter's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have low moderate penetration (lower than olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "sesame_seed_oil": {
      "name": "Sesame Seed Oil",
      "id": "sesame_seed_oil",
      "synonyms": [
        "sesamum indicum seed oil",
        "sesame oil"
      ],
      "categories": [
        "medium_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Sesame seed oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have moderate penetration (similar to olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "avocado_oil": {
      "name": "Avocado Oil",
      "id": "avocado_oil",
      "synonyms": [
        "persea gratissima oil",
        "avocado fruit oil"
      ],
      "categories": [
        "medium_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Avocado oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have moderate penetration (similar to olive oil, and much less than coconut oil)"
        },
        {
          "url": "https://www.mdpi.com/2079-9284/11/2/64",
          "title": "Impact of Hair Damage on the Penetration Profile of Coconut, Avocado, and Argan Oils into Caucasian Hair Fibers",
          "type": "science",
          "description": "Found that avocado oil didn't penetrate the hair shaft as well as argan oil, but did a better job protecting the hair from breakage."
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "corn_oil": {
      "name": "Corn Oil",
      "id": "corn_oil",
      "categories": [
        "medium_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Corn oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have moderate penetration (similar to olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "mustard_seed_oil": {
      "name": "Mustard Seed Oil",
      "id": "mustard_seed_oil",
      "categories": [
        "medium_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Mustard seed oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have moderate penetration (similar to olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "baobab_oil": {
      "name": "Baobab Oil",
      "id": "baobab_oil",
      "synonyms": [
        "adansonia digitata seed oil",
        "baobab seed oil"
      ],
      "categories": [
        "other_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "camellia_oil": {
      "name": "Camellia Oil",
      "id": "camellia_oil",
      "synonyms": [
        "camellia oleifera seed oil",
        "tea seed oil"
      ],
      "categories": [
        "light_oils"
      ],
      "references": [
        {
          "url": "https://pubmed.ncbi.nlm.nih.gov/38922913/",
          "title": "Penetration of oils into hair",
          "description": "Found that camellia oil can penetrate the hair shaft about as well as safflower oil, which is low-moderate compared to high penetration oils like coconut. It also found that camellia oil was just as good as coconut oil at preventing damage.",
          "type": "science"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "rice_bran_oil": {
      "name": "Rice bran oil",
      "id": "rice_bran_oil",
      "categories": [
        "light_oils"
      ],
      "synonyms": [
        "oryza sativa bran oil",
        "rice bran extract"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Rice bran oil's ability to penetrate (soak into) hair has been well-researched and found to be low. It's likely to coat the hair rather than soak in."
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "castor_oil": {
      "name": "Castor Oil",
      "id": "castor_oil",
      "synonyms": [
        "ricinus communis seed oil",
        "castor seed oil"
      ],
      "categories": [
        "medium_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "There isn't a lot of research into Castor Oil's ability to penetrate (soak into) hair, but it's likely given the oil's chemistry"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "hemp_seed_oil": {
      "name": "Hemp seed oil",
      "id": "hemp_seed_oil",
      "categories": [
        "light_oils"
      ],
      "synonyms": [
        "cannabis sativa seed oil",
        "hemp oil"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Hemp seed oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have low moderate penetration (lower than olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "coconut_oil": {
      "name": "Coconut Oil",
      "id": "coconut_oil",
      "synonyms": [
        "cocos nucifera oil",
        "coconut kernel oil"
      ],
      "categories": [
        "heavy_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Coconut oil is well documented to penetrate (soak into) hair"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "ucuuba_butter": {
      "name": "Ucuuba butter",
      "id": "ucuuba_butter",
      "categories": [
        "heavy_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Ucuuba butter is well documented to penetrate (soak into) hair"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "grapeseed_oil": {
      "name": "Grapeseed Oil",
      "id": "grapeseed_oil",
      "synonyms": [
        "vitis vinifera seed oil",
        "grape seed oil"
      ],
      "categories": [
        "light_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Grapeseed oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have low moderate penetration (lower than olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "jojoba_oil": {
      "name": "Jojoba Oil",
      "id": "jojoba_oil",
      "synonyms": [
        "simmondsia chinensis seed oil",
        "jojoba seed oil"
      ],
      "categories": [
        "light_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Jojoba oil is likely to coat the hair rather than soak in, based on its chemistry, so we consider it a light oil"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "lanolin_oil": {
      "name": "Lanolin oil",
      "id": "lanolin_oil",
      "categories": [
        "light_oils"
      ],
      "description": "Lanolin oil is derived from sheep's wool, so it is not vegan. It is a light oil that is likely to coat the hair rather than soak in, based on its chemistry. However, it is likely comedogenic (meaning it can clog pores), so it might not be good for people with oily scalps.",
      "references": [
        {
          "url": "https://www.cir-safety.org/sites/default/files/TAR_Lanolin_032024.pdf",
          "title": "CIR: Amended Safety Assessment of Lanolin-Derived Ingredients as Used in Cosmetics",
          "description": "Based on this analysis, lanolin seems to have a low percentage of fats that could penetrate the hair shaft",
          "type": "science"
        },
        {
          "url": "https://pubmed.ncbi.nlm.nih.gov/6229554/",
          "title": "Comedogenicity of current therapeutic products, cosmetics, and ingredients in the rabbit ear",
          "type": "science"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "marula_oil": {
      "name": "Marula Oil",
      "id": "marula_oil",
      "synonyms": [
        "sclerocarya birrea seed oil",
        "marula seed oil",
        "sclerocarya birrea"
      ],
      "categories": [
        "light_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "mineral_oil": {
      "name": "Mineral Oil",
      "id": "mineral_oil",
      "synonyms": [
        "paraffinum liquidum",
        "liquid paraffin",
        "petroleum oil"
      ],
      "categories": [
        "light_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Mineral oil is likely to coat the hair rather than soak in, based on its chemistry"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "olive_oil": {
      "name": "Olive Oil",
      "id": "olive_oil",
      "synonyms": [
        "olea europaea fruit oil",
        "olive fruit oil"
      ],
      "categories": [
        "medium_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Olive Oil's ability to penetrate (soak into) hair is well documented. It penetrates quite well, but not as well as heavy oils like coconut oil"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "flaxseed_oil": {
      "name": "Flaxseed Oil",
      "id": "flaxseed_oil",
      "synonyms": [
        "linum usitatissimum seed oil",
        "flax seed oil"
      ],
      "categories": [
        "light_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Flaxseed oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have low moderate penetration (lower than olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "sunflower_oil": {
      "name": "Sunflower Oil",
      "id": "sunflower_oil",
      "synonyms": [
        "helianthus annuus seed oil",
        "sunflower seed oil"
      ],
      "categories": [
        "heavy_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Sunflower oil is somewhat documented to penetrate (soak into) hair"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "palm_kernel_oil": {
      "name": "Palm kernel oil",
      "id": "palm_kernel_oil",
      "categories": [
        "heavy_oils"
      ],
      "synonyms": [
        "red palm oil"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Palm kernel oil's ability to penetrate (soak into) hair is not well researched, but is likely given the oil's chemistry"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "babbasu_oil": {
      "name": "Babbasu Oil",
      "id": "babbasu_oil",
      "categories": [
        "heavy_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Babbasu oil's ability to penetrate (soak into) hair hasn't been researched, but is likely given the oil's chemistry"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "sweet_almond_oil": {
      "name": "Sweet Almond Oil",
      "id": "sweet_almond_oil",
      "synonyms": [
        "prunus amygdalus dulcis oil",
        "almond oil"
      ],
      "categories": [
        "medium_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Sweet almond oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have moderate penetration (similar to olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "rosehip_oil": {
      "name": "Rosehip Oil",
      "id": "rosehip_oil",
      "synonyms": [
        "rosa canina seed oil",
        "rosehip seed oil"
      ],
      "categories": [
        "light_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Rosehip oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have low moderate penetration (lower than olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "perilla_oil": {
      "name": "Perilla Oil",
      "id": "perilla_oil",
      "synonyms": [
        "perilla frutescens seed oil",
        "perilla seed oil"
      ],
      "categories": [
        "light_oils"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Perilla oil's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have low moderate penetration (lower than olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "butyrospermum_parkii_shea_butter": {
      "name": "Butyrospermum Parkii Shea Butter",
      "id": "butyrospermum_parkii_shea_butter",
      "description": "A natural butter that deeply moisturizes and nourishes hair",
      "categories": [
        "medium_oils"
      ],
      "synonyms": [
        "shea butter",
        "butyrospermum parkii",
        "shea oil"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Shea butter's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have moderate penetration (similar to olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "kokum_butter": {
      "name": "Kokum Butter",
      "id": "kokum_butter",
      "categories": [
        "medium_oils"
      ],
      "synonyms": [
        "garcinia indica seed butter",
        "kokum seed butter"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Kokum butter's ability to penetrate (soak into) hair hasn't been well-researched but is it is likely to have moderate penetration (similar to olive oil, and much less than coconut oil)"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "vanilla_planifolia_fruit_oil": {
      "name": "Vanilla Planifolia Fruit Oil",
      "id": "vanilla_planifolia_fruit_oil",
      "categories": [
        "essential_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "peppermint_oil": {
      "name": "Peppermint Oil",
      "id": "peppermint_oil",
      "categories": [
        "essential_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "lavender_oil": {
      "name": "Lavender Oil",
      "id": "lavender_oil",
      "categories": [
        "essential_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "rosemary_oil": {
      "name": "Rosemary Oil",
      "id": "rosemary_oil",
      "categories": [
        "essential_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "tea_tree_oil": {
      "name": "Tea Tree Oil",
      "id": "tea_tree_oil",
      "categories": [
        "essential_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "squalane": {
      "name": "Squalane",
      "id": "squalane",
      "categories": [
        "light_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "citrus_aurantium_dulcis_peel_oil": {
      "name": "Citrus Aurantium Dulcis Peel Oil",
      "id": "citrus_aurantium_dulcis_peel_oil",
      "categories": [
        "essential_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "sulfated_castor_oil": {
      "name": "Sulfated Castor Oil",
      "id": "sulfated_castor_oil",
      "categories": [
        "light_oils"
      ],
      "synonyms": [
        "turkey red oil"
      ],
      "description": "A unique castor oil that has undergone a process known as 'sulfation', which makes it more water soluble than regular castor oil.",
      "references": [
        {
          "url": "https://www.fromnaturewithlove.com/SOAP/product.asp?product_id=OILTURK70US904",
          "title": "Turkey Red Oil (Sulfated Castor Oil), 70%",
          "type": "industry"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "aminomethyl_propanol": {
      "name": "Aminomethyl Propanol",
      "id": "aminomethyl_propanol",
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "disodium_2_sulfolaurate": {
      "name": "Disodium 2-Sulfolaurate",
      "id": "disodium_2_sulfolaurate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "potassium_castorate": {
      "name": "Potassium Castorate",
      "id": "potassium_castorate",
      "synonyms": [
        "potassium salt of castor oil fatty acids",
        "castor oil soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "soap": {
      "name": "Soap",
      "id": "soap",
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "potassium_cocoate": {
      "name": "Potassium Cocoate",
      "id": "potassium_cocoate",
      "synonyms": [
        "potassium salt of coconut oil fatty acids",
        "coconut oil soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "potassium_olivate": {
      "name": "Potassium Olivate",
      "id": "potassium_olivate",
      "synonyms": [
        "potassium salt of olive oil fatty acids",
        "olive oil soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "potassium_palmate": {
      "name": "Potassium Palmate",
      "id": "potassium_palmate",
      "synonyms": [
        "potassium salt of palmitic acid",
        "palm oil soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "potassium_stearate": {
      "name": "Potassium Stearate",
      "id": "potassium_stearate",
      "synonyms": [
        "potassium salt of stearic acid",
        "potassium soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "saccharomyces_silicon_ferment": {
      "name": "Saccharomyces Silicon Ferment",
      "id": "saccharomyces_silicon_ferment",
      "synonyms": [
        "saccharomycessilicon",
        "silicon ferment"
      ],
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "sodium_castorate": {
      "name": "Sodium Castorate",
      "id": "sodium_castorate",
      "synonyms": [
        "sodium salt of castor oil fatty acids",
        "castor oil soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_cocoate": {
      "name": "Sodium Cocoate",
      "id": "sodium_cocoate",
      "synonyms": [
        "sodium salt of coconut oil fatty acids",
        "coconut oil soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_lauroyl_hydrolyzed_silk": {
      "name": "Sodium Lauroyl Hydrolyzed Silk",
      "id": "sodium_lauroyl_hydrolyzed_silk",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_lauroyl_lactylate": {
      "name": "Sodium Lauroyl Lactylate",
      "id": "sodium_lauroyl_lactylate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_lauroyl_oat_amino_acids": {
      "name": "Sodium Lauroyl Oat Amino Acids",
      "id": "sodium_lauroyl_oat_amino_acids",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_methyl_2_sulfolaurate": {
      "name": "Sodium Methyl 2-Sulfolaurate",
      "id": "sodium_methyl_2_sulfolaurate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "sodium_olivate": {
      "name": "Sodium Olivate",
      "id": "sodium_olivate",
      "synonyms": [
        "sodium salt of olive oil fatty acids",
        "olive oil soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_palmate": {
      "name": "Sodium Palmate",
      "id": "sodium_palmate",
      "synonyms": [
        "sodium salt of palmitic acid",
        "palm oil soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_stearate": {
      "name": "Sodium Stearate",
      "id": "sodium_stearate",
      "synonyms": [
        "sodium salt of stearic acid",
        "stearic acid soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "sodium_tallowate": {
      "name": "Sodium Tallowate",
      "id": "sodium_tallowate",
      "synonyms": [
        "sodium salt of tallow fatty acids",
        "tallow soap"
      ],
      "categories": [
        "soaps"
      ],
      "status": "warning",
      "group": "surfactants"
    },
    "triisopropanolamine": {
      "name": "Triisopropanolamine",
      "id": "triisopropanolamine",
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "witch_hazel": {
      "name": "Witch Hazel",
      "id": "witch_hazel",
      "synonyms": [
        "witch",
        "hamamelis",
        "hamamellis",
        "hazel"
      ],
      "categories": [
        "astringents"
      ],
      "description": "Most witch hazel contains alcohol—check with the manufacturer to confirm. Even alcohol-free versions can be drying, so use cautiously on high porosity hair.",
      "status": "warning",
      "group": "others"
    },
    "unknown_paraben": {
      "name": "Unknown Paraben",
      "id": "unknown_paraben",
      "synonyms": [
        "paraben"
      ],
      "categories": [
        "parabens"
      ],
      "status": "ok",
      "group": "preservatives"
    },
    "water": {
      "name": "Water  ",
      "id": "water",
      "synonyms": [
        "aqua"
      ],
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "isododecane": {
      "name": "Solvent",
      "id": "isododecane",
      "categories": [
        "solvents"
      ],
      "status": "ok",
      "group": "others"
    },
    "isohexadecane": {
      "name": "Isohexadecane",
      "id": "isohexadecane",
      "synonyms": [
        "c16 hydrocarbon",
        "volatile hydrocarbon",
        "isohexanedecane",
        "isohexad"
      ],
      "categories": [
        "solvents"
      ],
      "status": "ok",
      "group": "others"
    },
    "flower_extract": {
      "name": "Flower Extract",
      "id": "flower_extract",
      "categories": [
        "other"
      ],
      "description": "This is a flower extract, but we're not sure which one. These are generally considered harmless or beneficial.",
      "status": "ok",
      "group": "others"
    },
    "aloe_barbadensis_leaf_extract": {
      "name": "Aloe Barbadensis Leaf Extract",
      "id": "aloe_barbadensis_leaf_extract",
      "description": "A moisturizing ingredient that soothes the scalp and conditions hair",
      "categories": [
        "film_forming_humectants"
      ],
      "synonyms": [
        "aloe vera",
        "aloe barbadensis leaf juice"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "flaxseed_extract": {
      "name": "Flaxseed Extract",
      "id": "flaxseed_extract",
      "synonyms": [
        "linum usitatissimum",
        "linseed"
      ],
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "carrageenan": {
      "name": "Carrageenan",
      "id": "carrageenan",
      "synonyms": [
        "chondrus crispus"
      ],
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "seaweed_extract": {
      "name": "Seaweed Extract",
      "id": "seaweed_extract",
      "categories": [
        "film_forming_humectants"
      ],
      "synonyms": [
        "seaweed"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "marshmallow_root_extract": {
      "name": "Marshmallow root Extract",
      "id": "marshmallow_root_extract",
      "synonyms": [
        "marshmallow"
      ],
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "irish_moss_extract": {
      "name": "Irish Moss Extract",
      "id": "irish_moss_extract",
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "pectin": {
      "name": "Pectin",
      "id": "pectin",
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "algae_extract": {
      "name": "Algae Extract",
      "id": "algae_extract",
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "citric_acid": {
      "name": "Citric Acid",
      "id": "citric_acid",
      "description": "Used to adjust pH levels and smooth hair cuticles",
      "categories": [
        "other"
      ],
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/citric-acid"
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "ethylhexylglycerin": {
      "name": "Ethylhexylglycerin",
      "id": "ethylhexylglycerin",
      "description": "A humectant and preservative enhancer",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "glycereth_26": {
      "name": "Glycereth-26",
      "id": "glycereth_26",
      "description": "A lightweight humectant that provides hydration without greasiness",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "glycerin": {
      "name": "Glycerin",
      "id": "glycerin",
      "description": "A powerful humectant that attracts moisture to the hair",
      "categories": [
        "simple_humectants"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Humectants in Personal Care Formulation",
          "type": "science",
          "author": "Gesslein, B.W.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "It's very good at holding water (equilibrium hygroscopicity) and is virtually non-toxic"
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hydroxyethylcellulose": {
      "name": "Hydroxyethylcellulose",
      "id": "hydroxyethylcellulose",
      "description": "A thickening agent that improves product texture",
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hydroxypropyltrimonium_honey": {
      "name": "Hydroxypropyltrimonium Honey",
      "id": "hydroxypropyltrimonium_honey",
      "description": "A conditioning agent derived from honey that adds shine and softness",
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "panthenol": {
      "name": "Panthenol",
      "id": "panthenol",
      "description": "A moisturizing and strengthening agent that enhances hair elasticity",
      "categories": [
        "simple_humectants"
      ],
      "synonyms": [
        "provitamin B5",
        "vitamin B5"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "butylene_glycol": {
      "name": "Butylene glycol",
      "id": "butylene_glycol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "sodium_hyaluronate": {
      "name": "Sodium hyaluronate",
      "id": "sodium_hyaluronate",
      "categories": [
        "simple_humectants"
      ],
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/sodium-hyaluronate",
          "title": "INCIDecoder: Sodium Hyaluronate",
          "description": "Says it's a huge polymer with a very large water holding capacity",
          "type": "science",
          "status": "good"
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "pca": {
      "name": "PCA",
      "id": "pca",
      "categories": [
        "simple_humectants"
      ],
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/pca",
          "title": "INCIDecoder: PCA",
          "type": "science",
          "status": "good"
        },
        {
          "url": "https://www.taylorfrancis.com/books/mono/10.1201/b16716/handbook-cosmetic-science-technology-andr%C3%A9-barel-marc-paye-howard-maibach",
          "title": "Handbook of Cosmetic Science and Technology",
          "description": "Mentions Panthenol can increase hair's volume",
          "type": "science"
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "phenoxyethanol": {
      "name": "Phenoxyethanol",
      "id": "phenoxyethanol",
      "description": "A preservative that prevents microbial growth in hair care products",
      "categories": [
        "other_preservatives"
      ],
      "status": "ok",
      "group": "preservatives"
    },
    "silk_amino_acids": {
      "name": "Silk Amino Acids",
      "id": "silk_amino_acids",
      "description": "A protein derivative that strengthens and smooths hair",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "sodium_phytate": {
      "name": "Sodium Phytate",
      "id": "sodium_phytate",
      "description": "A chelating agent that stabilizes product formulations",
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "sorbic_acid": {
      "name": "Sorbic Acid",
      "id": "sorbic_acid",
      "description": "A preservative that inhibits the growth of mold and yeast",
      "categories": [
        "other_preservatives"
      ],
      "status": "ok",
      "group": "preservatives"
    },
    "propylene_glycol": {
      "name": "Propylene Glycol",
      "id": "propylene_glycol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "tocopheryl_acetate": {
      "name": "Tocopheryl Acetate",
      "id": "tocopheryl_acetate",
      "description": "An antioxidant that protects hair and scalp from free radical damage",
      "categories": [
        "other"
      ],
      "synonyms": [
        "Vitamin E"
      ],
      "status": "ok",
      "group": "others"
    },
    "cellulose": {
      "name": "Cellulose",
      "id": "cellulose",
      "description": "A natural polymer used as a thickener and stabilizer in hair care formulations",
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "peg_100_stearate": {
      "name": "PEG-100 Stearate",
      "id": "peg_100_stearate",
      "description": "An emulsifier that helps blend water and oil, improving the texture and stability of hair care products",
      "categories": [
        "other"
      ],
      "synonyms": [
        "PEG 100 Stearate"
      ],
      "status": "ok",
      "group": "others"
    },
    "fragrance": {
      "name": "Fragrance",
      "id": "fragrance",
      "categories": [
        "other"
      ],
      "synonyms": [
        "parfum"
      ],
      "description": "A blend of aromatic compounds that provides a pleasant scent to hair care products. Some people are sensitive to fragrances and companies are not required to list which specific ingredients are used in their fragrance blends.",
      "status": "ok",
      "group": "others"
    },
    "guar_hydroxypropyltrimonium_chloride": {
      "name": "Guar Hydroxypropyltrimonium Chloride",
      "id": "guar_hydroxypropyltrimonium_chloride",
      "description": "A conditioning agent derived from guar gum, improving detangling and reducing static in hair",
      "categories": [
        "polyquats"
      ],
      "synonyms": [
        "guar gum quaternary ammonium",
        "cationic guar",
        "hydroxypropyl guar"
      ],
      "status": "ok",
      "group": "others"
    },
    "unknown_polyquat": {
      "name": "Unknown Polyquat",
      "id": "unknown_polyquat",
      "categories": [
        "polyquats"
      ],
      "synonyms": [
        "polyquaternium"
      ],
      "description": "We're pretty sure this is a polyquat, but we're not sure which one. Polyquats are a conditioning agent that can be used to help with detangling and styling.",
      "status": "ok",
      "group": "others"
    },
    "guar_gum": {
      "name": "Guar Gum",
      "id": "guar_gum",
      "categories": [
        "film_forming_agents"
      ],
      "synonyms": [
        "guar gum"
      ],
      "status": "ok",
      "group": "others"
    },
    "xanthan_gum": {
      "name": "Xanthan Gum",
      "id": "xanthan_gum",
      "categories": [
        "film_forming_agents"
      ],
      "status": "ok",
      "group": "others"
    },
    "magnesium_sulfate": {
      "name": "Magnesium Sulfate",
      "id": "magnesium_sulfate",
      "description": "A mineral salt used as a texturizer and curl enhancer in hair care products. Some people find the texture unpleasant or drying. If you have issues with hard water, you might want to avoid it, because it's an extra source of the same minerals that can build up on your hair.",
      "categories": [
        "other"
      ],
      "synonyms": [
        "epsom salt",
        "magnesium salt",
        "magnesium sulphate"
      ],
      "references": [
        {
          "url": "http://www.tightlycurly.com/ingredients/magnesium_sulfate",
          "title": "Magnesium Sulfate",
          "type": "author",
          "description": "Mentions that this ingredient roughs up the hair cuticle, which can be drying. It's also alkaline, which can swell the hair shaft, causing further damage.",
          "status": "warning"
        },
        {
          "url": "https://www.curlynikki.com/magnesium-sulfate-curly-friend-or-foe.html",
          "title": "Curly Nikki: Magnesium Sulfate- Curly Friend or Foe?",
          "type": "author",
          "description": "Says it's a powerful curl enhancer but can be drying to some so advises using with a leave in conditioner.",
          "status": "caution"
        },
        {
          "url": "https://ijdvl.com/scanning-electron-microscopy-study-of-hair-shaft-changes-related-to-hardness-of-water/",
          "title": "Scanning electron microscopy study of hair shaft changes related to hardness of water",
          "type": "science",
          "description": "Notes that Magnesium sulfate can be a component of hard water, which deposits on the hair. But did not find any evidence of damage."
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "phenyl_propanol": {
      "name": "Phenyl Propanol",
      "id": "phenyl_propanol",
      "synonyms": [
        "phenylpropanol"
      ],
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "lanolin": {
      "name": "Lanolin",
      "id": "lanolin",
      "categories": [
        "other_oils"
      ],
      "description": "This is an ingredient derived from wool with a complicated chemical structure and many uses. One issue with it is that it is comedogenic, meaning it can clog pores. This may be an issue for people with sensitive or dandruff prone scalps. It is also not vegan friendly.",
      "references": [
        {
          "url": "https://pubmed.ncbi.nlm.nih.gov/6229554/",
          "title": "Comedogenicity of current therapeutic products, cosmetics, and ingredients in the rabbit ear",
          "type": "science"
        }
      ],
      "status": "ok",
      "group": "oils"
    },
    "polysorbate_20": {
      "name": "Polysorbate 20",
      "id": "polysorbate_20",
      "synonyms": [
        "sorbitan monolaurate ethoxylated",
        "ethoxylated sorbitol laurate"
      ],
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "alanine": {
      "name": "Alanine",
      "id": "alanine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "arginine": {
      "name": "Arginine",
      "id": "arginine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "aspartic_acid": {
      "name": "Aspartic Acid",
      "id": "aspartic_acid",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "calcium_aspartate": {
      "name": "calcium aspartate",
      "id": "calcium_aspartate",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "calcium_glycinate": {
      "name": "Calcium Glycinate",
      "id": "calcium_glycinate",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "casein": {
      "name": "Casein",
      "id": "casein",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "collagen": {
      "name": "Collagen",
      "id": "collagen",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "cysteine": {
      "name": "Cysteine",
      "id": "cysteine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "dipotassium_aspartate": {
      "name": "Dipotassium aspartate",
      "id": "dipotassium_aspartate",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "elastin": {
      "name": "Elastin",
      "id": "elastin",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "gelatin": {
      "name": "Gelatin",
      "id": "gelatin",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "glutamic_acid": {
      "name": "Glutamic Acid",
      "id": "glutamic_acid",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "histidine": {
      "name": "Histidine",
      "id": "histidine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "lysine": {
      "name": "Lysine",
      "id": "lysine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "glycine": {
      "name": "Glycine",
      "id": "glycine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "keratin": {
      "name": "Keratin",
      "id": "keratin",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "magnesium_aspartate": {
      "name": "Magnesium aspartate",
      "id": "magnesium_aspartate",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "magnesium_glycinate": {
      "name": "Magnesium Glycinate",
      "id": "magnesium_glycinate",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "methionine": {
      "name": "Methionine",
      "id": "methionine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "milk": {
      "name": "Milk",
      "id": "milk",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "peptide": {
      "name": "Peptide",
      "id": "peptide",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "phenylalanine": {
      "name": "Phenylalanine",
      "id": "phenylalanine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "potassium_aspartate": {
      "name": "Potassium aspartate",
      "id": "potassium_aspartate",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "proline": {
      "name": "Proline",
      "id": "proline",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "serine": {
      "name": "Serine",
      "id": "serine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "unknown_protein": {
      "name": "Unknown Protein",
      "id": "unknown_protein",
      "synonyms": [
        "protein"
      ],
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "silk": {
      "name": "Silk",
      "id": "silk",
      "categories": [
        "proteins"
      ],
      "synonyms": [
        "sericin"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "sodium_aspartate": {
      "name": "Sodium aspartate",
      "id": "sodium_aspartate",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "sodium_glycinate": {
      "name": "Sodium Glycinate",
      "id": "sodium_glycinate",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "tyrosine": {
      "name": "Tyrosine",
      "id": "tyrosine",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "sodium_glutamate": {
      "name": "Sodium Glutamate",
      "id": "sodium_glutamate",
      "categories": [
        "proteins"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "acetamide_mea": {
      "name": "Acetamide MEA",
      "id": "acetamide_mea",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "agave_nectar": {
      "name": "Agave Nectar",
      "id": "agave_nectar",
      "synonyms": [
        "agave"
      ],
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "alantoin": {
      "name": "Alantoin",
      "id": "alantoin",
      "categories": [
        "simple_humectants"
      ],
      "synonyms": [
        "allantoin"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "caprylyl_glycol": {
      "name": "Caprylyl Glycol",
      "id": "caprylyl_glycol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "ceramide": {
      "name": "Ceramide",
      "id": "ceramide",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "dipropylene_glycol": {
      "name": "Dipropylene Glycol",
      "id": "dipropylene_glycol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "erythritol": {
      "name": "Erythritol",
      "id": "erythritol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "fructose": {
      "name": "Fructose",
      "id": "fructose",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "glucose": {
      "name": "Glucose",
      "id": "glucose",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "glyceryl_triacetate": {
      "name": "Glyceryl Triacetate",
      "id": "glyceryl_triacetate",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "glycogen": {
      "name": "Glycogen",
      "id": "glycogen",
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hexylene_glycol": {
      "name": "Hexylene Glycol",
      "id": "hexylene_glycol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "honey": {
      "name": "Honey",
      "id": "honey",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hyaluronic_acid": {
      "name": "Hyaluronic Acid",
      "id": "hyaluronic_acid",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "inositol": {
      "name": "Inositol",
      "id": "inositol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "lactic_acid": {
      "name": "Lactic Acid",
      "id": "lactic_acid",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "lecithin": {
      "name": "Lecithin",
      "id": "lecithin",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "maltitol": {
      "name": "Maltitol",
      "id": "maltitol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "molasses": {
      "name": "Molasses",
      "id": "molasses",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "niacinamide": {
      "name": "Niacinamide",
      "id": "niacinamide",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "phytantriol": {
      "name": "Phytantriol",
      "id": "phytantriol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "polydextrose": {
      "name": "Polydextrose",
      "id": "polydextrose",
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "polyethylene_glycol": {
      "name": "Polyethylene Glycol",
      "id": "polyethylene_glycol",
      "synonyms": [
        "polyethyleneglycol"
      ],
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "quillaja_saponaria_bark_extract": {
      "name": "Quillaja Saponaria Bark Extract",
      "id": "quillaja_saponaria_bark_extract",
      "categories": [
        "film_forming_humectants"
      ],
      "synonyms": [
        "quillaja",
        "quillaia"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "sodium_lactate": {
      "name": "Sodium Lactate",
      "id": "sodium_lactate",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "sodium_pca": {
      "name": "Sodium PCA",
      "id": "sodium_pca",
      "categories": [
        "simple_humectants"
      ],
      "synonyms": [
        "pyrrolidone carboxylic acid"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Humectants in Personal Care Formulation",
          "type": "science",
          "author": "Gesslein, B.W.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Moisture capacity 1.5 times greater than glycerin. Ability to hold water over time(dynamic hygroscopicity) is similar to glycerin"
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "sorbitol": {
      "name": "Sorbitol",
      "id": "sorbitol",
      "categories": [
        "simple_humectants"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Humectants in Personal Care Formulation",
          "type": "science",
          "author": "Gesslein, B.W.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "One of the best of the traditional humectants at holding water over time (dynamic hygroscopicity) though it holds less water than humectants like glycerin (equilibrium hygroscopicity)"
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "urea": {
      "name": "Urea",
      "id": "urea",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "xylitol": {
      "name": "Xylitol",
      "id": "xylitol",
      "categories": [
        "simple_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "isolaureth_6": {
      "name": "Isolaureth-6",
      "id": "isolaureth_6",
      "categories": [
        "other_emollients"
      ],
      "status": "ok",
      "group": "others"
    },
    "triethylhexanoin": {
      "name": "Triethylhexanoin",
      "id": "triethylhexanoin",
      "categories": [
        "other_emollients"
      ],
      "status": "ok",
      "group": "others"
    },
    "sodium_thiosulfate": {
      "name": "Sodium Thiosulfate",
      "id": "sodium_thiosulfate",
      "categories": [
        "other"
      ],
      "description": "Not a sulfate detergent, a harmless additive",
      "status": "ok",
      "group": "others"
    },
    "acrylates_copolymer": {
      "name": "Acrylates Copolymer",
      "id": "acrylates_copolymer",
      "categories": [
        "film_forming_agents"
      ],
      "status": "ok",
      "group": "others"
    },
    "dehydroxanthan_gum": {
      "name": "Dehydroxanthan Gum",
      "id": "dehydroxanthan_gum",
      "categories": [
        "film_forming_agents"
      ],
      "status": "ok",
      "group": "others"
    },
    "polyvinylpyrrolidone": {
      "name": "Polyvinylpyrrolidone",
      "id": "polyvinylpyrrolidone",
      "synonyms": [
        "PVP"
      ],
      "categories": [
        "film_forming_agents"
      ],
      "status": "ok",
      "group": "others"
    },
    "copolymer": {
      "name": "Copolymer",
      "id": "copolymer",
      "categories": [
        "film_forming_agents"
      ],
      "description": "This is an unknown copolymer, not in our db yet",
      "status": "ok",
      "group": "others"
    },
    "diheptyl_succindate": {
      "name": "Diheptyl Succinate",
      "id": "diheptyl_succindate",
      "categories": [
        "conditioning_agents"
      ],
      "synonyms": [
        "luxglide"
      ],
      "description": "This is a natural alternative to silicones, but like silicones, it doesn't seem to be water soluble",
      "references": [
        {
          "url": "https://www.wholesalesuppliesplus.com/handmade101/learn-to-make-articles/a-chemists-perspective-on-luxglide-n5-and-n350.aspx",
          "title": "A Chemist's Perspective on LuxGlide N5 & N350",
          "type": "industry",
          "description": "Mentions it's a natural alternative to silicone, which is oil soluble."
        },
        {
          "url": "https://incidecoder.com/ingredients/diheptyl-succinate",
          "title": "INCIDecoder: Diheptyl Succinate",
          "type": "science"
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "capryloyl_glycerin_sebacic_acid_copolymer": {
      "name": "Capryloyl Glycerin Sebacic Acid Copolymer",
      "id": "capryloyl_glycerin_sebacic_acid_copolymer",
      "categories": [
        "conditioning_agents"
      ],
      "description": "This is a natural alternative to silicones, but like silicones, it doesn't seem to be water soluble",
      "status": "ok",
      "group": "others"
    },
    "polyacrylate_crosspolymer_6": {
      "name": "Polyacrylate Crosspolymer-6",
      "id": "polyacrylate_crosspolymer_6",
      "categories": [
        "film_forming_agents"
      ],
      "status": "ok",
      "group": "others"
    },
    "maltodextrin_vp_copolymer": {
      "name": "Maltodextrin VP Copolymer",
      "id": "maltodextrin_vp_copolymer",
      "categories": [
        "film_forming_agents"
      ],
      "references": [
        {
          "url": "https://www.happi.com/unique-styling-products-via-maltodextrinvp/",
          "title": "Unique Styling Products Via Maltodextrin/VP",
          "type": "industry",
          "description": "Notes it is a natural ingredient used for providing hold and is easily washed out with water."
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "vp_va_copolymer": {
      "name": "VP VA copolymer",
      "id": "vp_va_copolymer",
      "categories": [
        "film_forming_agents"
      ],
      "description": "Humidity resistant ingredient that provides hold in products like gels",
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/vp-va-copolymer",
          "title": "INCIDecoder: VP/​VA Copolymer",
          "type": "science"
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "propanediol": {
      "name": "Propanediol",
      "id": "propanediol",
      "categories": [
        "simple_humectants"
      ],
      "description": "A natural alternative to propylene glycol",
      "status": "ok",
      "group": "humectants"
    },
    "linum_usitatissimum_seed_extract": {
      "name": "Linum Usitatissimum Seed Extract",
      "id": "linum_usitatissimum_seed_extract",
      "categories": [
        "film_forming_humectants"
      ],
      "synonyms": [
        "flax seed extract"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hydrolyzed_collagen": {
      "name": "Hydrolyzed Collagen",
      "id": "hydrolyzed_collagen",
      "categories": [
        "proteins"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed collagen with a molecular weight of 5000 to 15,000 Da is an excellent film-former that moisturizes the hair by coating the cuticle without deep absorption (film-former). Adds body, resiliency, shine, and manageability while reducing static."
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed collagen with a molecular weight of 2000 Da demonstrates substantivity to hair, meaning it adheres well to the hair's surface and penetrates its structure. Adheres best on damaged hair. Enhances tensile strength (resistance to breaking) and elasticity"
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed collagen temporarily mends split ends, particularly in leave-in products, though higher concentrations yield diminishing benefits for damaged hair."
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hydrolyzed_elastin": {
      "name": "Hydrolyzed elastin",
      "id": "hydrolyzed_elastin",
      "categories": [
        "proteins"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed elastin with a molecular weight of 2000 to 5000 Da is a good film-former, similar to hydrolyzed collagen. It is much less hygroscopic (less water-absorbing) than collagen due to its lower polar and charged amino acid content."
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Low-polarity protein hydrolysates like elastin and silk are preferable to collagen in applications where humidity resistance is desired."
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hydrolyzed_keratin": {
      "name": "Hydrolyzed keratin",
      "id": "hydrolyzed_keratin",
      "categories": [
        "proteins"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": " High-molecular-weight hydrolyzed keratin (125,000 Da) provides long-term substantivity and conditioning effects when applied to reduced hair during permanent waving."
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hydrolyzed_sweet_almond_protein": {
      "name": "Hydrolyzed Sweet Almond Protein",
      "id": "hydrolyzed_sweet_almond_protein",
      "categories": [
        "proteins"
      ],
      "description": "Acts like almost a hybrid between a protein and a film-forming humectant because it contains both proteins and carbohydrates",
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed sweet almond protein contains both polypeptides and oligosaccharides.Conditioning effects result from polypeptides penetrating the hair and oligosaccharides coating it.  "
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "In leave-in products, hydrolyzed sweet almond protein enhances moisture retention and shine."
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Strengthening of damaged hair and protection of hair fibers can be observed at use levels similar to those required for hydrolyzed collagen."
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hydrolyzed_wheat_protein": {
      "name": "Hydrolyzed Wheat Protein",
      "id": "hydrolyzed_wheat_protein",
      "categories": [
        "proteins"
      ],
      "description": "Acts like a hybrid between a film-forming humectant and a protein",
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed wheat protein and hydrolyzed wheat starch condition hair by both penetrating and coating, similar to hydrolyzed sweet almond protein."
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Substantivity to normal hair increases with concentration, peaking rapidly at 2% actives and plateauing above 5% actives."
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Studies on hair damaged with a 2% sodium hydroxide cream for 15 minutes showed that hydrolyzed wheat protein at 5% solids reduced brittleness at low relative humidity and limpness at high relative humidity."
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hydrolyzed_wheat_starch": {
      "name": "Hydrolyzed Wheat Starch",
      "id": "hydrolyzed_wheat_starch",
      "categories": [
        "film_forming_humectants"
      ],
      "description": "Acts like a hybrid between a film-forming humectant and a protein",
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed wheat protein and hydrolyzed wheat starch condition hair by both penetrating and coating, similar to hydrolyzed sweet almond protein."
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "hydrolyzed_oat_protein": {
      "name": "Hydrolyzed Oat Protein",
      "id": "hydrolyzed_oat_protein",
      "categories": [
        "proteins"
      ],
      "description": "Acts like a hybrid between a protein and a film-forming humectant because it contains both proteins and carbohydrates",
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed oat protein provides substantivity, shine, split-end repair, and a protective barrier to hair."
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "collagen_amino_acids": {
      "name": "Collagen Amino Acids",
      "id": "collagen_amino_acids",
      "categories": [
        "proteins"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Collagen amino acids are very good at attracting and holding onto moisture (hygroscopic). This makes them excellent for moisturizing hair. Penetration makes hair pliable and soft, particularly at high relative humidity."
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "wheat_amino_acids": {
      "name": "Wheat Amino Acids",
      "id": "wheat_amino_acids",
      "categories": [
        "proteins"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Wheat amino acid can function as humectants."
        }
      ],
      "status": "ok",
      "group": "humectants"
    },
    "apple_cider_vinegar": {
      "name": "Apple Cider Vinegar",
      "id": "apple_cider_vinegar",
      "categories": [
        "other"
      ],
      "references": [
        {
          "url": "https://www.semanticscholar.org/paper/No-sulfates%2C-no-parabens%2C-and-the-%22no-poo%22-method%3A-Cline-Uwakwe/6fc55d2ab974b0c2fa1e4fed7814e0bdf97447cb",
          "title": "No sulfates, no parabens, and the 'no-poo' method: a new patient perspective on common shampoo ingredients.",
          "type": "science",
          "author": "Cline, A. et al.",
          "date": "2018",
          "source": "Cutis",
          "description": "Has a low pH (3.1- 5) which is similar to the pH of the scalp/hair. Has antimicrobial properties. Capable of tightening the hair cuticle and has a mild cleansing ability. Advises that undiluted ACV may be hazardous to the eyes."
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "baking_soda": {
      "name": "Baking Soda",
      "id": "baking_soda",
      "categories": [
        "other"
      ],
      "synonyms": [
        "sodium bicarbonate"
      ],
      "description": "An alkaline substance that can damage the hair cuticle and cause breakage",
      "references": [
        {
          "url": "https://www.semanticscholar.org/paper/No-sulfates%2C-no-parabens%2C-and-the-%22no-poo%22-method%3A-Cline-Uwakwe/6fc55d2ab974b0c2fa1e4fed7814e0bdf97447cb",
          "title": "No sulfates, no parabens, and the 'no-poo' method: a new patient perspective on common shampoo ingredients.",
          "type": "science",
          "author": "Cline, A. et al.",
          "date": "2018",
          "source": "Cutis",
          "description": "It has a very high pH (9.5-10.5) which is very different from the pH of the scalp/hair. Can cause the cuticle to open up, allowing water to break up proteins like keratin and increasing negative charges in the hair. This lowers the elasticity of the hair and can cause breakage."
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "jojoba_esters": {
      "name": "Jojoba Esters",
      "id": "jojoba_esters",
      "categories": [
        "esters"
      ],
      "status": "ok",
      "group": "others"
    },
    "cetyl_esters": {
      "name": "Cetyl Esters",
      "id": "cetyl_esters",
      "categories": [
        "esters"
      ],
      "status": "ok",
      "group": "others"
    },
    "c12_15_alkyl": {
      "name": "C12-15 alkyl",
      "id": "c12_15_alkyl",
      "categories": [
        "esters"
      ],
      "status": "ok",
      "group": "others"
    },
    "unknown_ester": {
      "name": "Unknown Ester",
      "id": "unknown_ester",
      "categories": [
        "esters"
      ],
      "synonyms": [
        "ester"
      ],
      "status": "ok",
      "group": "others"
    },
    "sorbitol_esters": {
      "name": "Sorbitol Esters",
      "id": "sorbitol_esters",
      "categories": [
        "esters"
      ],
      "status": "ok",
      "group": "others"
    },
    "isopropanolamine": {
      "name": "Isopropanolamine",
      "id": "isopropanolamine",
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "hydrolyzed_corn_starch": {
      "name": "Hydrolyzed Corn Starch",
      "id": "hydrolyzed_corn_starch",
      "categories": [
        "film_forming_humectants"
      ],
      "status": "ok",
      "group": "humectants"
    },
    "caprylic_capric_triglyceride": {
      "name": "Caprylic Capric Triglyceride",
      "id": "caprylic_capric_triglyceride",
      "categories": [
        "esters"
      ],
      "synonyms": [
        "caprylic triglyceride",
        "capric triglyceride"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2013/06/oils-which-ones-soak-in-vs-coat-hair.html",
          "title": "Oils – Which Ones Soak In vs. Coat the Hair?",
          "type": "science",
          "description": "Capric / Caprylic triglycerides' ability to penetrate (soak into) hair hasn't been researched, but is likely given the oil's chemistry"
        },
        {
          "url": "https://link.springer.com/article/10.1186/s40691-023-00332-0",
          "title": "Determination of penetration and protection of fatty acids in bleached hair according to the fatty acid chain length and the application to understanding the protective effects of MCT oil and coconut oil",
          "type": "science"
        }
      ],
      "status": "ok",
      "group": "others"
    },
    "potassium_sorbate": {
      "name": "Potassium Sorbate",
      "id": "potassium_sorbate",
      "categories": [
        "other_preservatives"
      ],
      "status": "ok",
      "group": "preservatives"
    },
    "sodium_chloride": {
      "name": "Sodium Chloride",
      "id": "sodium_chloride",
      "categories": [
        "other"
      ],
      "status": "ok",
      "group": "others"
    },
    "rosmarinus_officinalis_rosemary_leaf_extract": {
      "name": "Rosmarinus officinalis rosemary leaf extract",
      "id": "rosmarinus_officinalis_rosemary_leaf_extract",
      "categories": [
        "other"
      ],
      "description": "Rosemary leaf extract is a botanical extract that is known to have anti-inflammatory and antimicrobial properties.",
      "status": "ok",
      "group": "others"
    },
    "disodium_edta": {
      "name": "Disodium EDTA",
      "id": "disodium_edta",
      "categories": [
        "other"
      ],
      "description": "Common product stabilizer",
      "status": "ok",
      "group": "others"
    },
    "chlorphenesin": {
      "name": "Chlorphenesin",
      "id": "chlorphenesin",
      "categories": [
        "other_preservatives"
      ],
      "status": "ok",
      "group": "preservatives"
    },
    "sodium_hydroxide": {
      "name": "Sodium Hydroxide",
      "id": "sodium_hydroxide",
      "categories": [
        "other"
      ],
      "description": "pH adjuster to help balance the product",
      "status": "ok",
      "group": "others"
    },
    "linalool": {
      "name": "Linalool",
      "id": "linalool",
      "categories": [
        "other"
      ],
      "description": "Common fragrance ingredient",
      "status": "ok",
      "group": "others"
    },
    "leuconostoc_radish_root_ferment_filtrate": {
      "name": "Leuconostoc Radish Root Ferment Filtrate",
      "id": "leuconostoc_radish_root_ferment_filtrate",
      "categories": [
        "other_preservatives"
      ],
      "description": "A natural preservative made from radishes",
      "status": "ok",
      "group": "preservatives"
    },
    "sodium_benzoate": {
      "name": "Sodium Benzoate",
      "id": "sodium_benzoate",
      "categories": [
        "other_preservatives"
      ],
      "description": "Common preservative",
      "status": "ok",
      "group": "preservatives"
    },
    "limonene": {
      "name": "Limonene",
      "id": "limonene",
      "categories": [
        "other"
      ],
      "description": "Common fragrance ingredient",
      "status": "ok",
      "group": "others"
    },
    "salvia_officinalis_sage_leaf_extract": {
      "name": "Salvia officinalis sage leaf extract",
      "id": "salvia_officinalis_sage_leaf_extract",
      "categories": [
        "other"
      ],
      "description": "Sage leaf extract",
      "status": "ok",
      "group": "others"
    },
    "tocopherol": {
      "name": "Tocopherol",
      "id": "tocopherol",
      "categories": [
        "other_emollients"
      ],
      "status": "ok",
      "group": "others"
    },
    "urtica_dioica_nettle_extract": {
      "name": "Urtica Dioica Nettle Extract",
      "id": "urtica_dioica_nettle_extract",
      "categories": [
        "other"
      ],
      "description": "Nettle extract",
      "status": "ok",
      "group": "others"
    },
    "citronellol": {
      "name": "Citronellol",
      "id": "citronellol",
      "categories": [
        "other"
      ],
      "description": "Common fragrance ingredient",
      "status": "ok",
      "group": "others"
    },
    "hydrolyzed_quinoa": {
      "name": "Hydrolyzed Quinoa",
      "id": "hydrolyzed_quinoa",
      "categories": [
        "proteins"
      ],
      "description": "Hydrolyzed quinoa",
      "status": "ok",
      "group": "humectants"
    },
    "vanillin": {
      "name": "Vanillin",
      "id": "vanillin",
      "categories": [
        "other"
      ],
      "description": "Common fragrance ingredient",
      "status": "ok",
      "group": "others"
    },
    "sodium_gluconate": {
      "name": "Sodium Gluconate",
      "id": "sodium_gluconate",
      "categories": [
        "other"
      ],
      "description": "If high in the ingredient list, it's probably a humectant. If low, it's probably used to balance the formula.",
      "status": "ok",
      "group": "others"
    },
    "amodimethicone": {
      "name": "Amodimethicone",
      "id": "amodimethicone",
      "synonyms": [
        "amine-functional dimethicone",
        "amino-modified silicone"
      ],
      "categories": [
        "non_water_soluble_silicones"
      ],
      "description": "While not water soluble, it is breathable and does not build up on top of itself.",
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Organo-Modified Siloxane Polymers for Conditioning",
          "type": "science",
          "author": "Abrutyn, Eric S.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "This is an Amino-functional silicone, which is a PDMS siloxane backbone with aminoalkyl groups. This adds positive charges, making it adhere better to hair (negatively charged) = increase substansitivity (ability to adhere and stay on hair)"
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Organo-Modified Siloxane Polymers for Conditioning",
          "type": "science",
          "author": "Abrutyn, Eric S.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Can be used as a heat protectant and to speed up drying time (by capillary displacement of water held betwen hair fibers). The film it forms can be retained through multiple washes but doesn't build up on top of itself."
        }
      ],
      "status": "warning",
      "group": "silicones"
    },
    "bis_peg_18_methyl_ether_dimethyl_silane": {
      "name": "Bis-PEG-18 Methyl Ether Dimethyl Silane",
      "id": "bis_peg_18_methyl_ether_dimethyl_silane",
      "synonyms": [
        "polyethylene glycol-18 methyl ether dimethyl silane",
        "dimethylsilane glycol ether"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "cetearyl_methicone": {
      "name": "Cetearyl Methicone",
      "id": "cetearyl_methicone",
      "synonyms": [
        "cetearyl dimethicone",
        "methicone ester"
      ],
      "categories": [
        "non_water_soluble_silicones"
      ],
      "status": "warning",
      "group": "silicones"
    },
    "cyclohexasiloxane": {
      "name": "Cyclohexasiloxane",
      "id": "cyclohexasiloxane",
      "synonyms": [
        "d6",
        "dodecamethylcyclohexasiloxane",
        "cyclohexamethicone"
      ],
      "categories": [
        "non_water_soluble_silicones"
      ],
      "status": "warning",
      "group": "silicones"
    },
    "cyclopentasiloxane": {
      "name": "Cyclopentasiloxane",
      "id": "cyclopentasiloxane",
      "synonyms": [
        "d5",
        "decamethylcyclopentasiloxane",
        "cyclopentamethicone"
      ],
      "categories": [
        "non_water_soluble_silicones"
      ],
      "status": "warning",
      "group": "silicones"
    },
    "dimethicone": {
      "name": "Dimethicone",
      "id": "dimethicone",
      "synonyms": [
        "polydimethylsiloxane",
        "pdms",
        "dimethylpolysiloxane"
      ],
      "categories": [
        "non_water_soluble_silicones"
      ],
      "description": "One of the most common silicones, this is a conditioning powerhouse, smoothing and protecting hair with ease. The major downside is it's not easy to wash out, so it can cause buildup.",
      "references": [
        {
          "url": "https://incidecoder.com/ingredients/dimethicone",
          "title": "INCIDecoder",
          "type": "science",
          "description": "notes it may be difficult to wash out",
          "status": "caution"
        },
        {
          "url": "http://www.tightlycurly.com/ingredients/",
          "title": "Tightly Curly Ingredients",
          "type": "author",
          "date": "2010",
          "source": "Tightly Curly",
          "description": "says it can be heavy but is a great conditioner",
          "status": "good"
        },
        {
          "url": "https://amzn.to/41QrGxJ",
          "title": "Curly Girl: The Handbook",
          "type": "hairpro",
          "author": "Massey L.",
          "date": "2011",
          "status": "warning"
        },
        {
          "url": "https://science-yhairblog.blogspot.com/2014/04/silicone-ingredient-solubility-list.html",
          "title": "Science-y Hair Blog",
          "description": "classifies as water insoluble, only should be used if you are using a cleanser capable of removing",
          "type": "science",
          "status": "caution"
        },
        {
          "url": "https://thebeautybrains.com/2007/01/are-silicones-bad-for-your-hair/",
          "title": "The Beauty Brains",
          "type": "science",
          "description": "says its great for lowering porosity but can be hard to wash out",
          "status": "caution"
        },
        {
          "url": "https://labmuffin.com/silicone-mythbusting-with-video/",
          "title": "Lab Muffin",
          "type": "science",
          "status": "good"
        }
      ],
      "status": "warning",
      "group": "silicones"
    },
    "dimethicone_copolyol": {
      "name": "Dimethicone Copolyol",
      "id": "dimethicone_copolyol",
      "synonyms": [
        "dimethicone polyethylene glycol ether",
        "dimethicone polyoxyethylene"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Specialty Silicone Conditioning Agents",
          "type": "science",
          "author": "O’Lenick, A.J.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Has both water, oil, and silicone soluble parts. Nonionic so can be used with aninoic surfactants in shampoos."
        }
      ],
      "status": "caution",
      "group": "silicones"
    },
    "dimethiconol": {
      "name": "Dimethiconol",
      "id": "dimethiconol",
      "synonyms": [
        "hydroxyl-terminated dimethicone",
        "dimethylsiloxane polymer"
      ],
      "categories": [
        "non_water_soluble_silicones"
      ],
      "status": "warning",
      "group": "silicones"
    },
    "lauryl_methicone_copolyol": {
      "name": "Lauryl Methicone Copolyol",
      "id": "lauryl_methicone_copolyol",
      "synonyms": [
        "lauryl polyethylene glycol dimethicone",
        "polyoxyethylene lauryl dimethicone"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "peg_10_dimethicone": {
      "name": "PEG-10 Dimethicone",
      "id": "peg_10_dimethicone",
      "synonyms": [
        "polyethylene glycol-10 dimethicone",
        "dimethicone polyether"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "peg_12_dimethicone": {
      "name": "PEG-12 Dimethicone",
      "id": "peg_12_dimethicone",
      "synonyms": [
        "polyethylene glycol-12 dimethicone",
        "dimethicone ethoxylate"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "peg_14_dimethicone": {
      "name": "PEG-14 Dimethicone",
      "id": "peg_14_dimethicone",
      "synonyms": [
        "polyethylene glycol-14 dimethicone",
        "dimethicone glycol ether"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "peg_7_amodimethicone": {
      "name": "PEG-7 Amodimethicone",
      "id": "peg_7_amodimethicone",
      "synonyms": [
        "polyether modified amodimethicone",
        "polyethylene glycol-7 amodimethicone"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "peg_8_dimethicone": {
      "name": "PEG-8 Dimethicone",
      "id": "peg_8_dimethicone",
      "synonyms": [
        "polyethylene glycol-8 dimethicone",
        "peg-modified dimethicone"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "phenyl_trimethicone": {
      "name": "Phenyl Trimethicone",
      "id": "phenyl_trimethicone",
      "synonyms": [
        "trimethylsilylphenyl dimethicone",
        "phenylmethylsilicone"
      ],
      "categories": [
        "non_water_soluble_silicones"
      ],
      "status": "warning",
      "group": "silicones"
    },
    "silicone_quaternium_8": {
      "name": "Silicone Quaternium-8",
      "id": "silicone_quaternium_8",
      "synonyms": [
        "cationic silicone polymer",
        "quaternized dimethicone"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2014/04/silicone-ingredient-solubility-list.html",
          "title": "Science-y Hair Blog",
          "description": "varies, discusses the different water solubilities of different silicones",
          "type": "science"
        }
      ],
      "status": "caution",
      "group": "silicones"
    },
    "stearoxytrimethylsilane": {
      "name": "Stearoxytrimethylsilane",
      "id": "stearoxytrimethylsilane",
      "synonyms": [
        "octadecyltrimethylsilane",
        "stearic acid trimethylsilane"
      ],
      "categories": [
        "non_water_soluble_silicones"
      ],
      "status": "warning",
      "group": "silicones"
    },
    "trimethylsiloxyamodimethicone": {
      "name": "Trimethylsiloxyamodimethicone",
      "id": "trimethylsiloxyamodimethicone",
      "synonyms": [
        "amino silicone resin",
        "amino-functionalized silicone"
      ],
      "categories": [
        "non_water_soluble_silicones"
      ],
      "status": "warning",
      "group": "silicones"
    },
    "trimethylsiloxysilicate": {
      "name": "Trimethylsiloxysilicate",
      "id": "trimethylsiloxysilicate",
      "categories": [
        "non_water_soluble_silicones"
      ],
      "status": "warning",
      "group": "silicones"
    },
    "cyclomethicone": {
      "name": "Cyclomethicone",
      "id": "cyclomethicone",
      "synonyms": [
        "cyclicdimethylpolysiloxane",
        "polydimethylcyclosiloxane"
      ],
      "categories": [
        "evaporative_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "silicone_quaternium_26": {
      "name": "Silicone Quaternium 26",
      "id": "silicone_quaternium_26",
      "categories": [
        "water_soluble_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "hydrolyzed_vegetable_protein_pg_propyl_silanetriol": {
      "name": "Hydrolyzed Vegetable Protein PG-propyl Silanetriol",
      "id": "hydrolyzed_vegetable_protein_pg_propyl_silanetriol",
      "synonyms": [
        "PG-propyl Silanetriol"
      ],
      "categories": [
        "water_soluble_silicones"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2014/04/silicone-ingredient-solubility-list.html",
          "title": "Science-y Hair Blog",
          "description": "varies, discusses the different water solubilities of different silicones",
          "type": "science"
        }
      ],
      "status": "caution",
      "group": "silicones"
    },
    "hydrolyzed_wheat_protein_hydroxypropyl_polysiloxane": {
      "name": "Hydrolyzed Wheat Protein Hydroxypropyl Polysiloxane",
      "id": "hydrolyzed_wheat_protein_hydroxypropyl_polysiloxane",
      "categories": [
        "water_soluble_silicones"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2014/04/silicone-ingredient-solubility-list.html",
          "title": "Science-y Hair Blog",
          "description": "varies, discusses the different water solubilities of different silicones",
          "type": "science"
        }
      ],
      "status": "caution",
      "group": "silicones"
    },
    "silanetriol": {
      "name": "Silanetriol",
      "id": "silanetriol",
      "categories": [
        "water_soluble_silicones"
      ],
      "references": [
        {
          "url": "https://science-yhairblog.blogspot.com/2014/04/silicone-ingredient-solubility-list.html",
          "title": "Science-y Hair Blog",
          "description": "varies, discusses the different water solubilities of different silicones",
          "type": "science"
        }
      ],
      "status": "caution",
      "group": "silicones"
    },
    "trimethylsilylamodimethicone": {
      "name": "Trimethylsilylamodimethicone",
      "id": "trimethylsilylamodimethicone",
      "categories": [
        "non_water_soluble_silicones"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Organo-Modified Siloxane Polymers for Conditioning",
          "type": "science",
          "author": "Abrutyn, Eric S.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "This is an Amino-functional silicone, which is a PDMS siloxane backbone with aminoalkyl groups. This adds positive charges, making it adhere better to hair (negatively charged) = increase substansitivity (ability to adhere and stay on hair)"
        }
      ],
      "status": "warning",
      "group": "silicones"
    },
    "silsesquioxane": {
      "name": "Silsesquioxane",
      "id": "silsesquioxane",
      "categories": [
        "non_water_soluble_silicones"
      ],
      "references": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Organo-Modified Siloxane Polymers for Conditioning",
          "type": "science",
          "author": "Abrutyn, Eric S.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "This is a Crosslinked Poly(dimethylsiloxanes). It is thought that the crosslinking improves substantivity (ability to adhere and stay on hair) without adding heaviness to the films it forms"
        }
      ],
      "status": "warning",
      "group": "silicones"
    },
    "bis_diisopropanolamino_pg_propyl_disiloxane_bis_vinyl_dimethicone": {
      "name": "Bis-diisopropanolamino-PG-propyl disiloxane/bis-vinyl dimethicone",
      "id": "bis_diisopropanolamino_pg_propyl_disiloxane_bis_vinyl_dimethicone",
      "categories": [
        "non_water_soluble_silicones"
      ],
      "synonyms": [
        "bis-vinyl dimethicone",
        "bis-diisopropanolamino-PG-propyl disiloxane"
      ],
      "references": [
        {
          "url": "https://www.dow.com/en-us/document-viewer.html?randomVar=8530979551752065537&docPath=/content/dam/dcc/documents/27/27-2/27-2861-01-hydroxyshield-polymer-product-guide.pdf",
          "title": "Hydroxyshield Polymer Product Guide",
          "type": "industry",
          "description": "This is HydroxySHIELD Polymer by Dow and it is a non-water soluble silicone"
        }
      ],
      "status": "warning",
      "group": "silicones"
    },
    "unknown_non_water_soluble_silicone": {
      "name": "Unknown Non-Water Soluble Silicone",
      "id": "unknown_non_water_soluble_silicone",
      "categories": [
        "non_water_soluble_silicones"
      ],
      "status": "warning",
      "group": "silicones"
    },
    "unknown_water_soluble_silicone": {
      "name": "Unknown Water Soluble Silicones",
      "id": "unknown_water_soluble_silicone",
      "categories": [
        "water_soluble_silicones"
      ],
      "status": "caution",
      "group": "silicones"
    },
    "unknown_sulfate": {
      "name": "Unknown Sulfate",
      "id": "unknown_sulfate",
      "categories": [
        "sulfates"
      ],
      "description": "We're pretty sure this is a sulfate, but we're not sure which one.",
      "status": "warning",
      "group": "surfactants"
    },
    "unknown_sarcosinate": {
      "name": "Unknown Sarcosinate",
      "id": "unknown_sarcosinate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "unknown_cocoyl_glutamate": {
      "name": "Unknown Cocoyl Glutamate",
      "id": "unknown_cocoyl_glutamate",
      "categories": [
        "other_anionic_surfactants"
      ],
      "status": "ok",
      "group": "surfactants"
    },
    "unknown_wax": {
      "name": "Unknown Wax",
      "id": "unknown_wax",
      "categories": [
        "non_water_soluble_waxes"
      ],
      "status": "warning",
      "group": "waxes"
    },
    "unknown_oil": {
      "name": "Unknown Oil",
      "id": "unknown_oil",
      "categories": [
        "other_oils"
      ],
      "status": "ok",
      "group": "oils"
    },
    "unknown_alcohol": {
      "name": "Unknown Alcohol",
      "id": "unknown_alcohol",
      "synonyms": [
        "alcohol"
      ],
      "description": "Unknown alcohol, since we don't know what it is, we are going to classify it as drying alcohols just to be safe.",
      "categories": [
        "drying_alcohols"
      ],
      "status": "caution",
      "group": "alcohols"
    },
    "unknown_essential_oil": {
      "name": "Unknown Essential Oil",
      "id": "unknown_essential_oil",
      "categories": [
        "essential_oils"
      ],
      "description": "Essential oils are not really oils as they are not fatty. They are mainly used for their fragrance and therapeutic properties.",
      "status": "ok",
      "group": "oils"
    },
    "beeswax": {
      "name": "Beeswax",
      "id": "beeswax",
      "synonyms": [
        "cera alba",
        "natural wax from bees",
        "cire dabeille"
      ],
      "categories": [
        "non_water_soluble_waxes"
      ],
      "status": "warning",
      "group": "waxes"
    },
    "candelilla_wax": {
      "name": "Candelilla Wax",
      "id": "candelilla_wax",
      "synonyms": [
        "euphorbia cerifera wax",
        "vegetable wax from candelilla shrub"
      ],
      "categories": [
        "non_water_soluble_waxes"
      ],
      "status": "warning",
      "group": "waxes"
    },
    "carnauba_wax": {
      "name": "Carnauba Wax",
      "id": "carnauba_wax",
      "synonyms": [
        "copernicia cerifera wax",
        "palm wax"
      ],
      "categories": [
        "non_water_soluble_waxes"
      ],
      "status": "warning",
      "group": "waxes"
    },
    "ceteareth_20": {
      "name": "Ceteareth-20",
      "id": "ceteareth_20",
      "synonyms": [
        "polyoxyethylene cetearyl ether",
        "ethoxylated cetearyl alcohol"
      ],
      "categories": [
        "water_soluble_waxes"
      ],
      "status": "ok",
      "group": "waxes"
    },
    "euphorbia_cerifera_wax": {
      "name": "Euphorbia Cerifera Wax",
      "id": "euphorbia_cerifera_wax",
      "synonyms": [
        "candelilla wax",
        "vegetable wax",
        "natural plant wax"
      ],
      "categories": [
        "non_water_soluble_waxes"
      ],
      "status": "warning",
      "group": "waxes"
    },
    "microcrystalline_wax": {
      "name": "Microcrystalline Wax",
      "id": "microcrystalline_wax",
      "synonyms": [
        "cera microcristallina",
        "cire microcristalline"
      ],
      "categories": [
        "non_water_soluble_waxes"
      ],
      "status": "warning",
      "group": "waxes"
    },
    "ozokerite": {
      "name": "Ozokerite",
      "id": "ozokerite",
      "synonyms": [
        "mineral wax",
        "earth wax"
      ],
      "categories": [
        "non_water_soluble_waxes"
      ],
      "status": "warning",
      "group": "waxes"
    },
    "paraffin_wax": {
      "name": "Paraffin Wax",
      "id": "paraffin_wax",
      "synonyms": [
        "paraffin",
        "petroleum-derived wax"
      ],
      "categories": [
        "non_water_soluble_waxes"
      ],
      "status": "warning",
      "group": "waxes"
    },
    "peg_12_carnauba_wax": {
      "name": "PEG-12 Carnauba Wax",
      "id": "peg_12_carnauba_wax",
      "synonyms": [
        "polyethylene glycol-12 carnauba wax",
        "ethoxylated carnauba wax"
      ],
      "categories": [
        "water_soluble_waxes"
      ],
      "status": "ok",
      "group": "waxes"
    },
    "peg_40_hydrogenated_castor_oil": {
      "name": "PEG-40 Hydrogenated Castor Oil",
      "id": "peg_40_hydrogenated_castor_oil",
      "synonyms": [
        "polyethylene glycol-40 hydrogenated castor oil",
        "ethoxylated castor oil"
      ],
      "categories": [
        "water_soluble_waxes"
      ],
      "status": "ok",
      "group": "waxes"
    },
    "peg_8_beeswax": {
      "name": "PEG-8 Beeswax",
      "id": "peg_8_beeswax",
      "synonyms": [
        "polyethylene glycol-8 beeswax",
        "ethoxylated beeswax"
      ],
      "categories": [
        "water_soluble_waxes"
      ],
      "status": "ok",
      "group": "waxes"
    },
    "petrolatum": {
      "name": "Petrolatum",
      "id": "petrolatum",
      "synonyms": [
        "petroleum jelly",
        "petrolatum",
        "paraffin jelly",
        "mineral jelly"
      ],
      "categories": [
        "non_water_soluble_waxes"
      ],
      "description": "Not a true wax, but functionally acts like one.Forms an extremely water repellent barrier on your hair that isn't breathable. Very hard to remove, worse than silicones. Not recommended.",
      "status": "warning",
      "group": "waxes"
    }
  },
  "categories": {
    "drying_alcohols": {
      "id": "drying_alcohols",
      "name": "Drying Alcohols",
      "group": "alcohols",
      "description": "Short-chain alcohols considered drying because they evaporate quickly and can strip natural oils from the hair and scalp"
    },
    "parabens": {
      "id": "parabens",
      "name": "Parabens",
      "group": "preservatives",
      "description": "Parabens are preservatives commonly used in cosmetic products to prevent bacterial growth",
      "inclusions": [
        "paraben"
      ],
      "defaultIngredient": "unknown_paraben"
    },
    "sulfates": {
      "id": "sulfates",
      "name": "Sulfates",
      "group": "surfactants",
      "description": "Sulfates are cleansing agents that create lather and remove oil and dirt",
      "inclusions": [
        "sulfate",
        "sulphate"
      ],
      "exclusions": [
        "behentrimonium",
        "methosulfate",
        "magnesium",
        "thiosulfate"
      ],
      "defaultIngredient": "unknown_sulfate"
    },
    "emollient_alcohols": {
      "id": "emollient_alcohols",
      "name": "Emollient alcohols",
      "group": "alcohols",
      "description": "These are long-chain fatty alcohols that help to soften and moisturize hair"
    },
    "water_soluble_silicones": {
      "id": "water_soluble_silicones",
      "name": "Water-soluble Silicones",
      "group": "silicones",
      "description": "Water-soluble silicones in hair care products are a type of silicone that is easily washed out of the hair with regular shampoo.",
      "inclusions": [
        "ppg",
        "peg"
      ],
      "exclusions": [
        "castor"
      ],
      "defaultIngredient": "unknown_water_soluble_silicone"
    },
    "non_water_soluble_silicones": {
      "id": "non_water_soluble_silicones",
      "name": "Non-water-soluble Silicones",
      "group": "silicones",
      "description": "Non-water-soluble silicones in hair care products are a type of silicone that cannot be easily washed out with gentle shampoos or cowash"
    },
    "other_oils": {
      "id": "other_oils",
      "name": "Other Oils",
      "group": "oils",
      "description": "These are other oils that don't fit into the other categories"
    },
    "other_anionic_surfactants": {
      "id": "other_anionic_surfactants",
      "name": "Other Anionic Surfactants",
      "group": "surfactants",
      "description": "Like sulfates, these are anionic surfactants, which means they have a negative charge and are good at removing oil and dirt from the hair"
    },
    "astringents": {
      "id": "astringents",
      "name": "Astringents",
      "group": "others",
      "description": "Astringents in hair care are substances that tighten pores and reduce oil production on the scalp"
    },
    "soaps": {
      "id": "soaps",
      "name": "Soaps",
      "group": "surfactants",
      "description": "Soaps are cleansers made from fatty acids and alkali metals"
    },
    "mild_surfactants": {
      "id": "mild_surfactants",
      "name": "Mild surfactants",
      "group": "surfactants",
      "description": "These surfactants are typically amphoteric or cationic and are considered to be gentler on the hair and scalp than anionic surfactants like sulfates. The cationic surfactants are primarily used for conditioning.",
      "notes": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Cationic Surfactants and Quaternary Derivatives for Hair and Skin Care",
          "type": "science",
          "author": "Jurczyk, M.J. et al.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Quaternary ammonium salts are positively charged, surfactant compounds that easily adhere to surfaces like hair."
        }
      ]
    },
    "heavy_oils": {
      "id": "heavy_oils",
      "name": "Heavy Oils and Butters",
      "group": "oils",
      "description": "These oils and butters are can penetrate (soak into) the hair shaft"
    },
    "light_oils": {
      "id": "light_oils",
      "name": "Light Oils",
      "group": "oils",
      "description": "Light oils have a low ability to penetrate (soak into) the hair shaft"
    },
    "medium_oils": {
      "id": "medium_oils",
      "name": "Medium Oils",
      "group": "oils",
      "description": "Medium oils have a moderate ability to penetrate (soak into) the hair shaft"
    },
    "non_water_soluble_waxes": {
      "id": "non_water_soluble_waxes",
      "name": "Non-water-soluble Waxes",
      "group": "waxes",
      "description": "Non-water-soluble waxes are waxes that are not easily washed out from hair"
    },
    "water_soluble_waxes": {
      "id": "water_soluble_waxes",
      "name": "Water-soluble Waxes",
      "group": "waxes",
      "description": "Water-soluble waxes are waxes that are easily washed out from hair"
    },
    "evaporative_silicones": {
      "id": "evaporative_silicones",
      "name": "Evaporative Silicones",
      "group": "silicones",
      "description": "Evaporative silicones are lightweight silicones that evaporate quickly, leaving no residue"
    },
    "other": {
      "id": "other",
      "name": "Other",
      "group": "others",
      "description": "These are other ingredients that don't fit into the other categories"
    },
    "solvents": {
      "id": "solvents",
      "name": "Solvents",
      "group": "others",
      "description": "Solvents are substances that dissolve other substances"
    },
    "polyquats": {
      "id": "polyquats",
      "name": "Polyquats",
      "group": "others",
      "description": "Polyquats are positively charged polymers used in haircare products to condition, detangle, and add shine by forming a protective film around the hair shaft.",
      "inclusions": [
        "polyquat"
      ],
      "defaultIngredient": "unknown_polyquat"
    },
    "petroleum_oils": {
      "id": "petroleum_oils",
      "name": "Petroleum Oils",
      "group": "oils",
      "description": "These are petroleum based ingredients that are often avoided for their build up potential as well as their petro-based origin."
    },
    "film_forming_humectants": {
      "id": "film_forming_humectants",
      "name": "Film Forming Humectants",
      "group": "humectants",
      "description": "These are large, complex molecules that may be better at retaining moisture in low humidity conditions"
    },
    "simple_humectants": {
      "id": "simple_humectants",
      "name": "Simple Humectants",
      "group": "humectants",
      "description": "These humectants may perform poorly in low humidity conditions"
    },
    "proteins": {
      "id": "proteins",
      "name": "Proteins",
      "group": "humectants",
      "description": "Proteins in hair care products can help strengthen and repair hair, but some people find them drying",
      "notes": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Humectants in Personal Care Formulation",
          "type": "science",
          "author": "Gesslein, B.W.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Found protein was less effective than traditional humectants (glycerin etc.) and performed especially badly in 79% relative humidity or below"
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Biology of the Hair and Skin",
          "type": "science",
          "author": "Draelos, Z.D.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed proteins (1000 to 10000 molecular weight) can diffuse into cortex through cuticle to strengthen hair, but washes out on cleansing."
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Proteins for Conditioning Hair and Skin",
          "type": "science",
          "author": "Neudahl, G.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Hydrolyzed proteins bound increases with hair damage. Help with cuticle damage and reducing brittleness"
        }
      ]
    },
    "other_preservatives": {
      "id": "other_preservatives",
      "name": "Other Preservatives",
      "group": "preservatives",
      "description": "These are other preservatives that don't fit into the other categories. They help prevent bacteria and mold from growing in the product."
    },
    "other_emollients": {
      "id": "other_emollients",
      "name": "Other Emollients",
      "group": "others",
      "description": "These are other emollients that don't fit into the other categories"
    },
    "conditioning_agents": {
      "id": "conditioning_agents",
      "name": "Conditioning Agents",
      "group": "others",
      "description": "These are conditioning agents that don't fit into the other categories"
    },
    "film_forming_agents": {
      "id": "film_forming_agents",
      "name": "Film Forming Agents",
      "group": "others",
      "description": "These ingredients form a thin invisible layer on the hair to hold style, prevent moisture loss, and protect from damage."
    },
    "essential_oils": {
      "id": "essential_oils",
      "name": "Essential Oils",
      "group": "oils",
      "inclusions": [
        "essential"
      ],
      "defaultIngredient": "unknown_essential_oil",
      "description": "Essential oils are not really oils as they are not fatty. They are mainly used for their fragrance and therapeutic properties."
    },
    "esters": {
      "id": "esters",
      "name": "Esters",
      "group": "others",
      "description": "Esters are used in hair care products as emollients, conditioners, and carriers for other ingredients, contributing to smoothness, shine, and manageability."
    }
  },
  "groups": {
    "alcohols": {
      "id": "alcohols",
      "name": "Alcohols",
      "inclusions": [
        "alcohol"
      ],
      "defaultIngredient": "unknown_alcohol",
      "description": "Alcohols in haircare products are used to help products dry quickly, preserve formulations, and enhance ingredient absorption into hair"
    },
    "preservatives": {
      "id": "preservatives",
      "name": "Preservatives",
      "inclusions": [
        "paraben"
      ],
      "description": "Preservatives in hair products can help prevent the growth of bacteria and mold"
    },
    "surfactants": {
      "id": "surfactants",
      "name": "Surfactants",
      "description": "surfactants in hair products can help remove dirt and oil from the hair and scalp",
      "inclusions": [
        "sulfate",
        "sulphate"
      ],
      "exclusions": [
        "magnesium",
        "behentrimonium",
        "methosulfate",
        "thiosulfate",
        "sulfated"
      ]
    },
    "silicones": {
      "id": "silicones",
      "name": "Silicones",
      "inclusions": [
        "cone",
        "dimethicon",
        "silane",
        "siloxane",
        "dimethcione",
        "botanisil",
        "silicon",
        "silylate",
        "silsesquioxane",
        "siloxysilicate",
        "microsil"
      ],
      "exclusions": [
        "saccharomycessilicon",
        "ferment",
        "castor",
        "polyquaternium"
      ],
      "defaultIngredient": "unknown_non_water_soluble_silicone",
      "description": "Synthetic ingredients that create a protective barrier on the hair, reducing friction and adding shine"
    },
    "others": {
      "id": "others",
      "name": "Others",
      "inclusions": []
    },
    "waxes": {
      "id": "waxes",
      "name": "Waxes",
      "inclusions": [
        "wax"
      ],
      "defaultIngredient": "unknown_wax",
      "exclusions": [
        "emulsifying"
      ],
      "description": "Waxes in styling products can add texture, hold, and shine to hair"
    },
    "oils": {
      "id": "oils",
      "name": "Oils",
      "inclusions": [
        "oil"
      ],
      "defaultIngredient": "unknown_oil",
      "description": "Oils in hair products can moisturize and add shine to hair"
    },
    "humectants": {
      "id": "humectants",
      "name": "Humectants",
      "description": "Humectants are ingredients that attract moisture to the hair",
      "inclusions": [],
      "notes": [
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Humectants in Personal Care Formulation",
          "type": "science",
          "author": "Gesslein, B.W.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "No known humectant performed well in study at 20% relative humidity and below"
        },
        {
          "url": "https://amzn.to/4hd4Tko",
          "title": "Humectants in Personal Care Formulation",
          "type": "science",
          "author": "Gesslein, B.W.",
          "date": "1999",
          "source": "Conditioning Agents for Hair and Skin",
          "description": "Humectants in shampoo likely do not remain in hair, but in leave ins they can form a film until washed, that can restore moisture to severely damaged hair"
        }
      ]
    }
  }
};

export const defaultSystems: System[] = [
  {
    "name": "Curly Default",
    "id": "curly_default",
    "description": "The Curly Default system is a hair care system that focuses on using products that are free of harsh chemicals and sulfates. It recommends using products that are free of drying alcohols, parabens, and other potentially harmful ingredients.",
    "settings": [
      "drying_alcohol",
      "caution_silicones",
      "no_waxes",
      "soap_free",
      "no_astringents",
      "no_water_insoluble_silicones",
      "sulfate_free",
      "no_petroleum"
    ]
  },
  {
    "name": "Curly Moderate",
    "id": "curly_moderate",
    "description": "Just like the default system, but allows for some water soluble silicones and moderate surfactants.",
    "settings": [
      "sulfate_free",
      "drying_alcohol",
      "no_water_insoluble_silicones",
      "no_waxes",
      "no_petroleum",
      "caution_silicones"
    ]
  },
  {
    "name": "Wavy",
    "id": "wavy",
    "description": "Allows stronger surfactants and avoid heavy oils",
    "settings": [
      "sulfate_free",
      "drying_alcohol",
      "no_water_insoluble_silicones",
      "no_waxes",
      "no_petroleum",
      "caution_silicones"
    ]
  }
];

export const defaultSettings: Record<string, Setting> = {
  "sulfate_free": {
    "id": "sulfate_free",
    "name": "Sulfates",
    "description": "Sulfates are a common ingredient in hair care products that can strip the hair of its natural oils. This can lead to dryness, especially for those with color-treated or chemically processed hair. Some people prefer to use sulfate-free products to maintain healthier hair.",
    "categories": [
      "sulfates"
    ],
    "defaultStatus": "warning",
    "guide": "/categories/sulfates"
  },
  "paraben_caution": {
    "id": "paraben_caution",
    "name": "Parabens",
    "description": "Parabens are preservatives used to extend the shelf life of hair care products, but some people avoid them due to potential health concerns.",
    "categories": [
      "parabens"
    ],
    "defaultStatus": "caution",
    "guide": "/categories/parabens"
  },
  "drying_alcohol": {
    "id": "drying_alcohol",
    "name": "Alcohols",
    "description": "These alcohols have a reputation for being drying, but may be fine in some formulations, especially in low amounts and in products that evaporate quickly.",
    "categories": [
      "drying_alcohols"
    ],
    "defaultStatus": "caution",
    "guide": "/groups/alcohols"
  },
  "silicone_free": {
    "id": "silicone_free",
    "name": "Silicones",
    "description": "Silicones are synthetic ingredients that can provide hair benefits but may build up, leading to potential hair issues.",
    "groups": [
      "silicones"
    ],
    "defaultStatus": "warning"
  },
  "mild_surfactants_only": {
    "id": "mild_surfactants_only",
    "name": "Stronger surfactants",
    "description": "Avoid these if you prefer mild surfactants.",
    "groups": [
      "surfactants"
    ],
    "allowedCategories": [
      "mild_surfactants"
    ],
    "defaultStatus": "warning",
    "allowedStatus": "ok",
    "guide": "/groups/surfactants"
  },
  "mild_surfactants_caution_others": {
    "id": "mild_surfactants_caution_others",
    "name": "Non-mild surfactants",
    "description": "These surfactants are not as harsh as sulfates but can still be drying for some hair types depending on the formulation. CurlsBot is revisiting many of these so you should do your own research.",
    "groups": [
      "surfactants"
    ],
    "allowedCategories": [
      "mild_surfactants"
    ],
    "defaultStatus": "caution",
    "allowedStatus": "ok",
    "guide": "/groups/surfactants"
  },
  "no_astringents": {
    "id": "no_astringents",
    "name": "No Astringents",
    "description": "Astringents are substances that tighten pores and reduce oil production, which can be beneficial for people with oily scalps, but can be too drying for those with dry or normal hair.",
    "categories": [
      "astringents"
    ],
    "defaultStatus": "warning"
  },
  "no_water_insoluble_silicones": {
    "id": "no_water_insoluble_silicones",
    "name": "Water Insoluble Silicones",
    "description": "These are silicones that are not water-soluble and can build up on the hair if you don't use a cleansing shampoo",
    "categories": [
      "non_water_soluble_silicones"
    ],
    "defaultStatus": "warning",
    "guide": "/groups/silicones"
  },
  "caution_silicones": {
    "id": "caution_silicones",
    "name": "Silicones",
    "description": "Some find these water-soluble and evaporative silicones are fine but we mark all silicones as caution in case you want to avoid them.",
    "groups": [
      "silicones"
    ],
    "defaultStatus": "caution",
    "guide": "/groups/silicones"
  },
  "no_waxes": {
    "id": "no_waxes",
    "name": "Non-water-soluble waxes",
    "description": "These waxes can coat the hair shaft, providing temporary benefits like shine, smoothness, and heat protection. However, they can build up on the hair, leading to a heavy, greasy feel and potentially hindering moisture absorption.",
    "categories": [
      "non_water_soluble_waxes"
    ],
    "defaultStatus": "warning",
    "guide": "/groups/waxes"
  },
  "soap_free": {
    "id": "soap_free",
    "name": "Soap",
    "description": "Soaps can be harsh on hair, stripping away natural oils and potentially leading to dryness, frizz, and damage, especially for those with color-treated or chemically processed hair. They can also build up on the hair when combined with hard water.",
    "categories": [
      "soaps"
    ],
    "defaultStatus": "warning",
    "guide": "/categories/soap"
  },
  "no_petroleum": {
    "id": "no_petroleum",
    "name": "Petroleum Oils",
    "description": "These are petroleum based ingredients that are often avoided for their build up potential as well as their petro-based origin.",
    "categories": [
      "petroleum_oils"
    ],
    "defaultStatus": "warning",
    "guide": "/categories/petroleum-oils"
  }
};

export function getBundledDatabase(): IngredientDatabase {
  return defaultDatabase;
}

export function getBundledSystems(): System[] {
  return defaultSystems;
}

export function getBundledSettings(): Record<string, Setting> {
  return defaultSettings;
}
